import {
  QUESTION_RESPONSE_STATUSES,
  QUESTIONNAIRE_STATUS,
} from '@retracedgmbh/modules/questionnaires/contracts';
import dataPoints from '@/lib/data-points';
import allCountries from './countries';
export const countries = allCountries;

export const arrayize = obj =>
  Object.keys(obj).map(k => ({ label: obj[k], value: k }));

export const countriesMapping = countries.reduce(
  (acc, obj) => ({ ...acc, [obj.countryCode]: obj.countryNameEn }),
  {},
);
export const countriesSelectArray = arrayize(countriesMapping);
export const countriesSelectArrayOptions = Object.keys(countriesMapping).map(
  k => ({ key: k, text: countriesMapping[k] }),
);
export const countriesCurrencyMapping = countries.reduce(
  (acc, obj) => ({ ...acc, [obj.currencyCode]: obj.currencyNameEn }),
  {},
);
export const countriesCurrencyDropdownSelectOptions = Object.keys(
  countriesCurrencyMapping,
)
  .map(k => ({
    value: k,
    label: k,
    key: k,
    text: k,
  }))
  .filter(c => c.value)
  .sort((a, b) => a.label.localeCompare(b.label));
export const productItemTypes = {};
productItemTypes.raw = {
  TO_BE_SHIPPED: 'To be shipped',
  TO_BE_RECEIVED: 'To be received',
  TO_BE_TAGGED: 'To be tagged',
};
productItemTypes.mapping = { ...productItemTypes.raw };
productItemTypes.selectArrayOptions = Object.keys(productItemTypes.mapping)
  .map(k => ({ key: k, text: productItemTypes.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

// Temp for assessment mapping
export const countriesList = {};
countriesList.selectArrayOptions = Object.keys(countriesMapping).map(k => ({
  key: k,
  text: countriesMapping[k],
}));
countriesList.mapping = countriesMapping;

export const phoneNumberPrefixes = countries.map(c => c.countryCallingCode);

export const countryList = countries
  .sort((n1, n2) => n1.countryNameEn.localeCompare(n2.countryNameEn))
  .map(c => ({
    name: c.countryNameEn,
    code: c.countryCode,
  }));

export const countriesLanguage = {};

countriesLanguage.mapping = countries.reduce(
  (acc, obj) => ({
    ...acc,
    [obj.officialLanguageCode]: obj.officialLanguageNameEn,
  }),
  {},
);
countriesLanguage.selectArrayOptions = Object.keys(countriesLanguage.mapping)
  .map(k => ({ key: k, text: countriesLanguage.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text))
  .filter(c => c.text);

export const materialTags = [
  { value: 'Plant', icon: 'seedling' },
  { value: 'Semi-synthetic', icon: 'flask' },
  { value: 'Synthetic', icon: 'flask' },
  { value: 'Animal', icon: 'paw' },
  { value: 'Animal or synthetic', icon: 'question' },
];

export const notificationResourceTypes = [
  { value: 'COMPANIES', text: 'Companies', label: 'company', color: '#FCF4DA' },
  {
    value: 'DOCUMENTS',
    text: 'Documents',
    label: 'document',
    color: '#EFE8DD',
  },
  {
    value: 'CERTIFICATE',
    text: 'Certifications',
    label: 'certificate',
    color: '#DDEFDD',
  },
  {
    value: 'MEMBERSHIP',
    text: 'Memberships',
    label: 'membership',
    color: '#F5F5F5',
  },
  { value: 'BADGE', text: 'Badges', label: 'badge', color: '#EFDDDD' },
  { value: 'AUDITS', text: 'Audits', label: '', color: '#F4EAF4' },
  { value: 'TRACING', text: 'Tracing', label: '', color: '#FCE8DA' },
  {
    value: 'SUPPLIER-NETWORK-SHARING',
    text: 'Companies',
    label: '',
    color: '#FCF4DA',
  },
  {
    value: 'RISK-ANALYSIS',
    text: 'Risk analysis',
    label: '',
    color: '#DADFFC',
  },
  { value: 'CAPA', text: 'CAPA', label: '', color: '#DAFCF4' },
  {
    value: 'QUESTIONNAIRES',
    text: 'Questionnaires',
    label: '',
    color: '#EAF0F4',
  },
  {
    value: 'CASCADE-MAPPING',
    text: 'Cascade Mapping',
    label: '',
    color: '#FCE8DA',
  },
  {
    value: 'COLLABORATIVE-PRODUCT-MAPPING',
    text: 'Collaborative Product Mapping',
    label: '',
    color: '#FCE8DA',
  },
  { value: 'REPORTS', text: 'Reports', label: '', color: '#C8CFD7' },
  { value: 'SLCP', text: 'SLCP', label: 'SLCP', color: '#DDEFDD' },
  {
    value: 'ENTITY-SCREENING',
    text: 'Entity Screening',
    label: 'Entity Screening',
    color: '#FFE5E5',
  },
  { value: 'STYLES', text: 'Styles', label: 'style', color: '#DEE7F0' },
];
notificationResourceTypes.selectArrayOptions = notificationResourceTypes
  .map(u => ({ key: u.value, text: u.text }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const notificationTriggers = {};
notificationTriggers.raw = {
  amforiSyncReport: 'amfori-sync-report',
  actionAttachmentsAdded: 'ACTION_ATTACHMENTS_ADDED',
  actionAttachmentsRemoved: 'ACTION_ATTACHMENTS_REMOVED',
  actionChildAdded: 'ACTION_CHILD_ADDED',
  actionChildRemoved: 'ACTION_CHILD_REMOVED',
  actionCommentAdded: 'ACTION_COMMENT_ADDED',
  actionCommentChanged: 'ACTION_COMMENT_CHANGED',
  actionCommentRemoved: 'ACTION_COMMENT_REMOVED',
  actionCreated: 'ACTION_CREATED',
  actionDescriptionChanged: 'ACTION_DESCRIPTION_CHANGED',
  actionDueDateChanged: 'ACTION_DUE_DATE_CHANGED',
  actionImpactAreaIdChanged: 'ACTION_IMPACT_AREA_ID_CHANGED',
  actionIsArchivedChanged: 'ACTION_IS_ARCHIVED_CHANGED',
  actionParentChanged: 'ACTION_PARENT_CHANGED',
  actionPriorityChanged: 'ACTION_PRIORITY_CHANGED',
  actionRemoved: 'ACTION_REMOVED',
  actionSourceIdChanged: 'ACTION_SOURCE_ID_CHANGED',
  actionSourceTypeChanged: 'ACTION_SOURCE_TYPE_CHANGED',
  actionStatusChanged: 'ACTION_STATUS_CHANGED',
  actionTitleChanged: 'ACTION_TITLE_CHANGED',
  auditInformationUpdatedAfterExtraction:
    'audit-information-updated-after-extraction',
  auditRequested: 'audit-requested',
  claimApproved: 'claim-approved',
  claimRejected: 'claim-rejected',
  companyCollaboratorAdded: 'COMPANY_COLLABORATOR_ADDED',
  companyCollaboratorRemoved: 'COMPANY_COLLABORATOR_REMOVED',
  companyLinked: 'company-linked',
  companyOwnerAdded: 'COMPANY_OWNER_ADDED',
  documentRequested: 'document-requested',
  documentShared: 'document-shared',
  fiberTransactionCreated: 'fiber-transactions-created',
  networkCertificateExpired: 'network-certificate-expired',
  nextPlannedAudit: 'next-planned-audit',
  ownCertificatesExpired: 'own-certificates-expired',
  ownCertificatesExpiring: 'own-certificates-expiring',
  productsImported: 'products-imported',
  questionnaireArchived: 'questionnaire-archived',
  questionnaireChangesRequested: 'questionnaire-change-requested',
  questionnaireCommented: 'questionnaire-commented',
  questionnaireDueDateChanged: 'questionnaire-due-date-changed',
  questionnaireExported: 'questionnaire-exported',
  questionnaireInvitation: 'questionnaire-invitation',
  questionnaireQuestionAdded: 'questionnaire-question-added',
  questionnaireReminder: 'questionnaire-reminder',
  questionnaireResponseSubmitted: 'questionnaire-response-submitted',
  questionnaireReviewCompleted: 'questionnaire-review-completed',
  questionnaireUnarchived: 'questionnaire-unarchived',
  ownQuestionnaireDueDateClosing: 'own-questionnaire-due-date-closing',
  requestQuestionnaireDueDateClosing:
    'requested-questionnaire-due-date-closing',
  riskScoreUpdated: 'risk-score-updated',
  usersAssigneeAdded: 'USERS_ASSIGNEE_ADDED',
  usersAssigneeRemoved: 'USERS_ASSIGNEE_REMOVED',
  usersReporterAdded: 'USERS_REPORTER_ADDED',
  usersReporterRemoved: 'USERS_REPORTER_REMOVED',
  usersCollaboratorAdded: 'USERS_COLLABORATOR_ADDED',
  usersWatcherAdded: 'USERS_WATCHER_ADDED',
  usersWatcherRemoved: 'USERS_WATCHER_REMOVED',
  supplyChainCollaborationRequested: 'cascade-mapping-collaborator-invited',
  supplyChainCollaborationRequestReminded:
    'cascade-mapping-collaborator-invitation-reminded',
  supplyChainCollaborationAccepted: 'cascade-mapping-collaboration-accepted',
  supplyChainCollaborationSubmitted: 'cascade-mapping-collaboration-submitted',
  supplyChainCollaborationChangesRequested:
    'cascade-mapping-collaboration-changes-requested',
  supplyChainCollaborationApproved: 'cascade-mapping-collaboration-approved',
  cpmCollaboratorInvited: 'cpm-collaborator-invited',
  cpmCollaboratorInReview: 'cpm-collaborator-in-review',
  cpmCollaboratorChangesRequested: 'cpm-collaborator-changes-requested',
  cpmCollaboratorApproved: 'cpm-collaborator-approved',
  cpmCollaboratorAccepted: 'cpm-collaborator-accepted',
  reportsTracingOperationsExport: 'reports-tracing-operations-export',
  reportsCertificatesComplianceExport: 'reports-certificates-compliance-export',
  slcpAdded: 'slcp-added',
  slcpAssessmentAccessRequested: 'slcp-assessment-access-requested',
  slcpAssessmentMissingAccessRequest: 'slcp-assessment-missing-access-request',
  slcpAssessmentShared: 'slcp-assessment-shared',
  slcpAssessmentSharedToCompanyWithFeatureDisabled:
    'slcp-assessment-shared-to-companie-with-feature-disabled',
  entityScreeningKharonMatch: 'entity-screening-kharon-match',
  entityScreeningUflpaMatch: 'entity-screening-uflpa-match',
  stylesExportCompleted: 'styles-export-completed',
  stylesExportFailed: 'styles-export-failed',
  stylesBulkImportCompleted: 'styles-bulk-import-completed',
  bomBulkImportCompleted: 'bom-bulk-import-completed',
  certifiedMaterialsPoImportCompleted:
    'certified-materials-po-import-completed',
  certifiedMaterialsSupplierNewEvidenceRequested:
    'certified-materials-supplier-new-evidence-requested',
  certifiedMaterialsOrderSubmittedForReview:
    'certified-materials-order-submitted-for-review',
  certifiedMaterialsDocumentRevisionRequested:
    'certified-materials-document-revision-requested',
  certifiedMaterialsSupplierReminderSent:
    'certified-materials-supplier-reminder-sent',
  cpmImportCompleted: 'cpm-import-completed',
  cpmExportCompleted: 'cpm-export-completed',
  cpmExportFailed: 'cpm-export-failed',
  networkCompaniesExport: 'network-companies-export',

  // CAPA-V2
  capUserAssigneeAdded: 'CAP_USER_ASSIGNEE_ADDED',
  capaUserAssigneeAdded: 'CAPA_USER_ASSIGNEE_ADDED',
  capUserAssigneeAddedGeneral: 'CAP_USER_ASSIGNEE_ADDED_GENERAL',
  capaUserAssigneeAddedGeneral: 'CAPA_USER_ASSIGNEE_ADDED_GENERAL',
  capUserAssigneeRemoved: 'CAP_USER_ASSIGNEE_REMOVED',
  capUserAssigneeRemovedGeneral: 'CAP_USER_ASSIGNEE_REMOVED_GENERAL',
  capaUserAssigneeRemoved: 'CAPA_USER_ASSIGNEE_REMOVED',
  capaUserAssigneeRemovedGeneral: 'CAPA_USER_ASSIGNEE_REMOVED_GENERAL',
  capCollaboratorAdded: 'CAP_COLLABORATOR_ADDED',
  capCollaboratorAddedGeneral: 'CAP_COLLABORATOR_ADDED_GENERAL',
  capCollaboratorRemoved: 'CAP_COLLABORATOR_REMOVED',
  capCollaboratorRemovedGeneral: 'CAP_COLLABORATOR_REMOVED_GENERAL',
  capaCollaboratorAdded: 'CAPA_COLLABORATOR_ADDED',
  capaCollaboratorAddedGeneral: 'CAPA_COLLABORATOR_ADDED_GENERAL',
  capaCollaboratorRemoved: 'CAPA_COLLABORATOR_REMOVED',
  capaCollaboratorRemovedGeneral: 'CAPA_COLLABORATOR_REMOVED_GENERAL',
  capaResponsibleCompanyAdded: 'CAPA_RESPONSIBLE_COMPANY_ADDED',
  capResponsibleCompanyAdded: 'CAP_RESPONSIBLE_COMPANY_ADDED',
  capOverdue: 'CAP_OVERDUE',
  capaOverdue: 'CAPA_OVERDUE',
  capDueSoon: 'CAP_DUE_SOON',
  capaDueSoon: 'CAPA_DUE_SOON',
  capaStatusUpdateInProgressGeneral: 'CAPA_STATUS_UPDATE_IN_PROGRESS_GENERAL',
  capaStatusUpdateInReview: 'CAPA_STATUS_UPDATE_IN_REVIEW',
  capaStatusUpdateInReviewGeneral: 'CAPA_STATUS_UPDATE_IN_REVIEW_GENERAL',
  capaStatusUpdateChangesRequested: 'CAPA_STATUS_UPDATE_CHANGES_REQUESTED',
  capaStatusUpdateChangesRequestedGeneral:
    'CAPA_STATUS_UPDATE_CHANGES_REQUESTED_GENERAL',
  capaStatusUpdateDoneGeneral: 'CAPA_STATUS_UPDATE_DONE_GENERAL',
  capaRemediationAdded: 'CAPA_REMEDIATION_ADDED',
  capaRemediationRemoved: 'CAPA_REMEDIATION_REMOVED',
  capaCommentAdded: 'CAPA_COMMENT_ADDED',
  capaCommentAddedGeneral: 'CAPA_COMMENT_ADDED_GENERAL',
  capCommentAdded: 'CAP_COMMENT_ADDED',
  capCommentAddedGeneral: 'CAP_COMMENT_ADDED_GENERAL',
};

export const cascadeMapHistoryActions = {
  COMPANY_REPLACED: 'COMPANY_REPLACED',
  COMPANY_DELETED: 'COMPANY_DELETED',
  COMPANY_LINKED: 'COMPANY_LINKED',
  FACILITY_PROCESS_UPDATED: 'FACILITY_PROCESS_UPDATED',
  SUPPLY_CHAIN_CREATED: 'SUPPLY_CHAIN_CREATED',
  INVITATION_ACCEPTED: 'INVITATION_ACCEPTED',
};

export const cascadeMapCollaborationRights = {
  Creator: 'Creator',
  Collaborator: 'Collaborator',
};

export const cascadeMapCollaborationTypes = {
  Creator: 'CREATOR',
  Collaborator: 'COLLABORATOR',
};

export const cascadeMapProgressStatus = {
  COMPLETED: 'COMPLETED',
  IN_REVIEW: 'IN_REVIEW',
  IN_PROGRESS: 'IN_PROGRESS',
};

export const notificationStatuses = {
  read: 'READ',
  unread: 'UNREAD',
  DISMISSED: 'DISMISSED',
  PENDING: 'PENDING',
};

export const shipmentMethods = {};
shipmentMethods.raw = {
  SEA: 'Sea',
  LAND: 'Land',
  AIR: 'Air',
};

shipmentMethods.mapping = { ...shipmentMethods.raw };
shipmentMethods.selectArrayOptions = Object.keys(shipmentMethods.raw)
  .map(k => ({ key: k, text: shipmentMethods.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const shipmentMethodsArray = arrayize(shipmentMethods.raw);

export const colors = {
  aliceblue: '#f0f8ff',
  antiquewhite: '#faebd7',
  aqua: '#00ffff',
  aquamarine: '#7fffd4',
  azure: '#f0ffff',
  beige: '#f5f5dc',
  bisque: '#ffe4c4',
  black: '#000000',
  blanchedalmond: '#ffebcd',
  blue: '#0000ff',
  blueviolet: '#8a2be2',
  brown: '#a52a2a',
  burlywood: '#deb887',
  cadetblue: '#5f9ea0',
  chartreuse: '#7fff00',
  chocolate: '#d2691e',
  coral: '#ff7f50',
  cornflowerblue: '#6495ed',
  cornsilk: '#fff8dc',
  crimson: '#dc143c',
  cyan: '#00ffff',
  darkblue: '#00008b',
  darkcyan: '#008b8b',
  darkgoldenrod: '#b8860b',
  darkgray: '#a9a9a9',
  darkgreen: '#006400',
  darkgrey: '#a9a9a9',
  darkkhaki: '#bdb76b',
  darkmagenta: '#8b008b',
  darkolivegreen: '#556b2f',
  darkorange: '#ff8c00',
  darkorchid: '#9932cc',
  darkred: '#8b0000',
  darksalmon: '#e9967a',
  darkseagreen: '#8fbc8f',
  darkslateblue: '#483d8b',
  darkslategray: '#2f4f4f',
  darkslategrey: '#2f4f4f',
  darkturquoise: '#00ced1',
  darkviolet: '#9400d3',
  deeppink: '#ff1493',
  deepskyblue: '#00bfff',
  dimgray: '#696969',
  dimgrey: '#696969',
  dodgerblue: '#1e90ff',
  firebrick: '#b22222',
  floralwhite: '#fffaf0',
  forestgreen: '#228b22',
  fuchsia: '#ff00ff',
  gainsboro: '#dcdcdc',
  ghostwhite: '#f8f8ff',
  goldenrod: '#daa520',
  gold: '#ffd700',
  gray: '#808080',
  green: '#008000',
  greenyellow: '#adff2f',
  grey: '#808080',
  honeydew: '#f0fff0',
  hotpink: '#ff69b4',
  indianred: '#cd5c5c',
  indigo: '#4b0082',
  ivory: '#fffff0',
  khaki: '#f0e68c',
  lavenderblush: '#fff0f5',
  lavender: '#e6e6fa',
  lawngreen: '#7cfc00',
  lemonchiffon: '#fffacd',
  lightblue: '#add8e6',
  lightcoral: '#f08080',
  lightcyan: '#e0ffff',
  lightgoldenrodyellow: '#fafad2',
  lightgray: '#d3d3d3',
  lightgreen: '#90ee90',
  lightgrey: '#d3d3d3',
  lightpink: '#ffb6c1',
  lightsalmon: '#ffa07a',
  lightseagreen: '#20b2aa',
  lightskyblue: '#87cefa',
  lightslategray: '#778899',
  lightslategrey: '#778899',
  lightsteelblue: '#b0c4de',
  lightyellow: '#ffffe0',
  lime: '#00ff00',
  limegreen: '#32cd32',
  linen: '#faf0e6',
  magenta: '#ff00ff',
  maroon: '#800000',
  mediumaquamarine: '#66cdaa',
  mediumblue: '#0000cd',
  mediumorchid: '#ba55d3',
  mediumpurple: '#9370db',
  mediumseagreen: '#3cb371',
  mediumslateblue: '#7b68ee',
  mediumspringgreen: '#00fa9a',
  mediumturquoise: '#48d1cc',
  mediumvioletred: '#c71585',
  midnightblue: '#191970',
  mintcream: '#f5fffa',
  mistyrose: '#ffe4e1',
  moccasin: '#ffe4b5',
  navajowhite: '#ffdead',
  navy: '#000080',
  oldlace: '#fdf5e6',
  olive: '#808000',
  olivedrab: '#6b8e23',
  orange: '#ffa500',
  orangered: '#ff4500',
  orchid: '#da70d6',
  palegoldenrod: '#eee8aa',
  palegreen: '#98fb98',
  paleturquoise: '#afeeee',
  palevioletred: '#db7093',
  papayawhip: '#ffefd5',
  peachpuff: '#ffdab9',
  peru: '#cd853f',
  pink: '#ffc0cb',
  plum: '#dda0dd',
  powderblue: '#b0e0e6',
  purple: '#800080',
  rebeccapurple: '#663399',
  red: '#ff0000',
  retracedblue: '#394E6C',
  rosybrown: '#bc8f8f',
  royalblue: '#4169e1',
  saddlebrown: '#8b4513',
  salmon: '#fa8072',
  sandybrown: '#f4a460',
  seagreen: '#2e8b57',
  seashell: '#fff5ee',
  sienna: '#a0522d',
  silver: '#c0c0c0',
  skyblue: '#87ceeb',
  slateblue: '#6a5acd',
  slategray: '#708090',
  slategrey: '#708090',
  snow: '#fffafa',
  springgreen: '#00ff7f',
  steelblue: '#4682b4',
  tan: '#d2b48c',
  teal: '#008080',
  thistle: '#d8bfd8',
  tomato: '#ff6347',
  turquoise: '#40e0d0',
  violet: '#ee82ee',
  wheat: '#f5deb3',
  white: '#ffffff',
  whitesmoke: '#f5f5f5',
  yellow: '#ffff00',
  yellowgreen: '#9acd32',
};

export const prioritizationColors = [
  '#cfdde8',
  '#a5c2d4',
  '#75a2bb',
  '#5376a4',
  '#406b89',
];

export const units = [
  // Volume
  {
    label: 'l',
    search: 'Litre',
    value: 'LITRE',
    quantity: 'volume',
    system: 'metric',
  },
  {
    label: 'ml',
    search: 'Millilitre',
    value: 'MILLILITRE',
    quantity: 'volume',
    system: 'metric',
  },
  {
    label: 'cl',
    search: 'Centilitre',
    value: 'CENTILITRE',
    quantity: 'volume',
    system: 'metric',
  },
  {
    label: 'dm³',
    search: 'Cubic decimetre',
    value: 'CUBIC_DECIMETRE',
    quantity: 'volume',
    system: 'metric',
  },
  {
    label: 'm³',
    search: 'Cubic metre',
    value: 'CUBIC_METRE',
    quantity: 'volume',
    system: 'metric',
  },
  {
    label: 'Gallon',
    search: 'Gallon',
    value: 'GALLON',
    quantity: 'volume',
  },
  {
    label: 'Quart',
    search: 'Quart',
    value: 'QUART',
    quantity: 'volume',
  },
  {
    label: 'Pint',
    search: 'Pint',
    value: 'PINT',
    quantity: 'volume',
  },
  {
    label: 'Gill',
    search: 'Gill',
    value: 'GILL',
    quantity: 'volume',
  },
  {
    label: 'Fluid ounce',
    search: 'Fluid ounce',
    value: 'FLUID_OUNCE',
    quantity: 'volume',
  },
  {
    label: 'Fluid dram',
    search: 'Fluid dram',
    value: 'FLUID_DRAM',
    quantity: 'volume',
  },
  {
    label: 'Minim',
    search: 'Minim',
    value: 'MINIM',
    quantity: 'volume',
  },
  {
    label: 'Bushel',
    search: 'Bushel',
    value: 'BUSHEL',
    quantity: 'volume',
  },
  {
    label: 'Acre foot',
    search: 'Acre foot',
    value: 'ACRE_FOOT',
    quantity: 'volume',
  },
  {
    label: 'Cord',
    search: 'Cord',
    value: 'CORD',
    quantity: 'volume',
  },
  {
    label: 'yd³',
    search: 'Cubic yard',
    value: 'CUBIC_YARD',
    quantity: 'volume',
  },
  {
    label: 'ft³',
    search: 'Cubic feet',
    value: 'CUBIC_FOOT',
    quantity: 'volume',
  },
  {
    label: 'in³',
    search: 'Cubic inch',
    value: 'CUBIC_INCH',
    quantity: 'volume',
  },
  {
    label: 'Peck',
    search: 'Peck',
    value: 'PECK',
    quantity: 'volume',
  },

  // Length
  {
    label: 'm',
    search: 'Metre',
    value: 'METRE',
    quantity: 'length',
    system: 'metric',
  },
  {
    label: 'm',
    search: 'Meter',
    value: 'METRE',
    quantity: 'length',
    system: 'metric',
  },
  {
    label: 'dm',
    search: 'Decimetre',
    value: 'DECIMETRE',
    quantity: 'length',
    system: 'metric',
  },
  {
    label: 'mm',
    search: 'Millimetre',
    value: 'MILLIMETRE',
    quantity: 'length',
    system: 'metric',
  },
  {
    label: 'cm',
    search: 'Centimetre',
    value: 'CENTIMETRE',
    quantity: 'length',
    system: 'metric',
  },
  {
    label: 'in',
    search: 'Inch',
    value: 'INCH',
    quantity: 'length',
  },
  {
    label: 'Nautical mile',
    search: 'Nautical mile',
    value: 'NAUTICAL_MILE',
    quantity: 'length',
  },
  {
    label: 'Mile',
    search: 'Mile',
    value: 'MILE',
    quantity: 'length',
  },
  {
    label: 'Furlong',
    search: 'Furlong',
    value: 'FURLONG',
    quantity: 'length',
  },

  {
    label: 'Rod',
    search: 'Rod',
    value: 'ROD',
    quantity: 'length',
  },
  {
    label: 'Fathom',
    search: 'Fathom',
    value: 'FATHOM',
    quantity: 'length',
  },
  {
    label: 'yd',
    search: 'Yard',
    value: 'YARD',
    quantity: 'length',
  },
  {
    label: 'ft',
    search: 'Foot',
    value: 'FOOT',
    quantity: 'length',
  },

  // Weight or mass
  {
    label: 'g',
    search: 'Gram',
    value: 'GRAM',
    quantity: 'weight',
    system: 'metric',
  },
  {
    label: 'g/m²',
    search: 'Grams per square meter',
    value: 'GRAM_PER_SQUARE_METER',
    quantity: 'weight',
    system: 'metric',
  },
  {
    label: 'g/ft²',
    search: 'Grams per square foot',
    value: 'GRAM_PER_SQUARE_FOOT',
    quantity: 'weight',
    system: 'metric',
  },
  {
    label: 'g/yd²',
    search: 'Grams per square yard',
    value: 'GRAM_PER_SQUARE_YARD',
    quantity: 'weight',
    system: 'metric',
  },
  {
    label: 'oz/yd²',
    search: 'Ounce per square yard',
    value: 'OUNCE_PER_SQUARE_YARD',
    quantity: 'weight',
    system: 'imperial',
  },
  {
    label: 'mg',
    search: 'Milligram',
    value: 'MILLIGRAM',
    quantity: 'weight',
    system: 'metric',
  },
  {
    label: 'kg',
    search: 'Kilogram',
    value: 'KILOGRAM',
    quantity: 'weight',
    system: 'metric',
  },
  {
    label: 't',
    search: 'Tonne',
    value: 'METRIC_TON',
    quantity: 'weight',
    system: 'metric',
  },
  {
    label: 'lb',
    search: 'Pounds',
    value: 'POUNDS',
    quantity: 'weight',
    system: 'imperial',
  },
  {
    label: 'Short ton',
    search: 'Short ton',
    value: 'SHORT_TON',
    quantity: 'weight',
  },
  {
    label: 'Long ton',
    search: 'Long ton',
    value: 'LONG_TON',
    quantity: 'weight',
  },
  {
    label: 'Hundredweight',
    search: 'Hundredweight',
    value: 'HUNDREDWEIGHT',
    quantity: 'weight',
  },
  {
    label: 'Short hundredweight',
    search: 'Short hundredweight',
    value: 'SHORT_HUNDREDWEIGHT',
    quantity: 'weight',
  },
  {
    label: 'Long hundredweight',
    search: 'Long hundredweight',
    value: 'LONG_HUNDREDWEIGHT',
    quantity: 'weight',
  },
  {
    label: 'oz',
    search: 'Ounce',
    value: 'OUNCE',
    quantity: 'weight',
    system: 'imperial',
  },
  {
    label: 'Dram',
    search: 'Dram',
    value: 'DRAM',
    quantity: 'weight',
  },
  {
    label: 'Grain',
    search: 'Grain',
    value: 'GRAIN',
    quantity: 'weight',
  },
  {
    label: 'Pennyweight',
    search: 'Pennyweight',
    value: 'PENNYWEIGHT',
    quantity: 'weight',
  },
  {
    label: 'Scruple',
    search: 'Scruple',
    value: 'SCRUPLE',
    quantity: 'weight',
  },
  {
    label: 'Stone',
    search: 'Stone',
    value: 'STONE',
    quantity: 'weight',
  },

  // Area
  {
    label: 'm²',
    search: 'Square metre',
    value: 'SQUARE_METRE',
    quantity: 'area',
    system: 'metric',
  },
  {
    label: 'dm²',
    search: 'Square decimetre',
    value: 'SQUARE_DECIMETRE',
    quantity: 'area',
    system: 'metric',
  },
  {
    label: 'cm²',
    search: 'Square centimetre',
    value: 'SQUARE_CENTIMETRE',
    quantity: 'area',
    system: 'metric',
  },
  {
    label: 'in²',
    search: 'Square inch',
    value: 'SQUARE_INCH',
    quantity: 'area',
  },
  {
    label: 'ml²',
    search: 'Sqaure mile',
    value: 'SQUARE_MILE',
    quantity: 'area',
  },
  {
    label: 'ft²',
    search: 'Square feet',
    value: 'SQUARE_FEET',
    quantity: 'area',
  },
  {
    label: 'rod²',
    search: 'Square rod',
    value: 'SQUARE_ROD',
    quantity: 'area',
  },
  {
    label: 'yd²',
    search: 'Sqaure yard',
    value: 'SQUARE_YARD',
    quantity: 'area',
  },

  // Other
  {
    label: 'pcs',
    search: 'Pieces',
    value: 'PIECES',
  },
  {
    label: 'pr',
    search: 'Pair',
    value: 'PAIR',
  },
  {
    label: 'Percentage',
    search: 'Percentage',
    value: 'PERCENTAGE',
  },
  {
    label: 'Rolls',
    search: 'Rolls',
    value: 'ROLL',
  },
  {
    label: 'Denier',
    search: 'Denier',
    value: 'DENIER',
  },
  {
    label: 'Jute (lbs/spyndle)',
    search: 'Jute',
    value: 'JUTE',
  },
  {
    label: 'English Count',
    search: 'English count',
    value: 'ENGLISH_COUNT',
  },
  {
    label: 'Metric Count',
    search: 'Metric count',
    value: 'METRIC_COUNT',
  },
  {
    label: 'Worsted Count',
    search: 'Worsted count',
    value: 'WORSTED_COUNT',
  },
  {
    label: 'Tex',
    search: 'Tex',
    value: 'TEX',
  },
];

units.mapping = units
  .sort((a, b) => a.label.localeCompare(b.label))
  .reduce((acc, obj) => ({ ...acc, [obj.value]: obj.label }), {});
units.enumMapping = units.reduce(
  (acc, obj) => ({ ...acc, [obj.value]: obj.value }),
  {},
);
units.searchMapping = units
  .sort((a, b) => a.search.localeCompare(b.search))
  .reduce((acc, obj) => ({ ...acc, [obj.value]: obj.search }), {});
units.selectArrayOptions = units
  .map(u => ({ key: u.value, text: u.search, label: u.label }))
  .sort((a, b) => a.label.localeCompare(b.label));
units.selectArrayKilogramOrMetric = units
  .filter(r => r.value === 'KILOGRAM' || r.value === 'METRIC_TON')
  .map(u => ({ key: u.value, text: u.search, label: u.label }))
  .sort((a, b) => a.label.localeCompare(b.label));

units.selectArrayMetricOptions = additional =>
  units
    .filter(u => u.system === 'metric' || additional.includes(u.value))
    .map(u => ({ key: u.value, text: u.search, label: u.label }))
    .sort((a, b) => a.label.localeCompare(b.label));
units.selectArrayMetricOptionsByQuantity = quantity =>
  units
    .filter(
      u =>
        u.quantity === quantity &&
        (u.system === 'metric' || u.system === 'imperial'),
    )
    .map(u => ({ key: u.value, text: u.search, label: u.label }))
    .sort((a, b) => a.label.localeCompare(b.label));
units.selectArrayOptionsByValue = value =>
  units
    .filter(u => value.includes(u.value))
    .map(u => ({
      key: u.value,
      text: u.search,
      label: u.label,
      value: u.value,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
// Units a BOM line accepts when the component's style type configures none.
// Mirrors QUANTITY_UNITS in the backend, which is what the endpoint validates
// against in that case — a wider list here would offer values the API rejects.
units.defaultBomQuantityUnitOptions = units.selectArrayOptionsByValue([
  'PIECES',
  'PAIR',
  'PERCENTAGE',
  'DENIER',
  'JUTE',
  'ENGLISH_COUNT',
  'METRIC_COUNT',
  'WORSTED_COUNT',
  'TEX',
  'GRAM',
  'KILOGRAM',
  'LITRE',
  'METRIC_TON',
  'MILLIMETRE',
  'CENTIMETRE',
  'METRE',
  'SQUARE_CENTIMETRE',
  'SQUARE_METRE',
]);
units.selectArrayMetricDropDownOptionsByValue = value =>
  value &&
  units
    .filter(u => u.system === 'metric' && value.includes(u.value))
    .map(u => ({ value: u.value, label: u.label }))
    .sort((a, b) => a.label.localeCompare(b.label));

export const companySizes = {};
companySizes.raw = {
  FROM_0_TO_1: '0 - 1',
  FROM_2_TO_10: '2 - 10',
  FROM_11_TO_50: '11 - 50',
  FROM_51_TO_200: '51 - 200',
  FROM_201_TO_500: '201 - 500',
  FROM_501_TO_1000: '501 - 1000',
  FROM_1001_TO_5000: '1001 - 5000',
  FROM_5001_TO_10000: '5001 - 10000',
  FROM_10001_TO_INFINITE: 'More than 10000',
};
companySizes.mapping = { ...companySizes.raw };
companySizes.selectArrayOptions = Object.keys(companySizes.mapping).map(k => ({
  key: k,
  text: companySizes.mapping[k],
}));
companySizes.selectOptions = Object.keys(companySizes.mapping).map(k => ({
  id: k,
  name: companySizes.mapping[k],
}));

export const supportedLanguages = {};
supportedLanguages.raw = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  pt: 'Português',
  tr: 'Türkçe',
  vi: 'Tiếng Việt',
  zh: '中文',
};
supportedLanguages.mapping = { ...supportedLanguages.raw };
supportedLanguages.selectArrayOptions = Object.keys(
  supportedLanguages.mapping,
).map(k => ({
  key: k,
  text: supportedLanguages.mapping[k],
}));

export const companyTypesList = {};
companyTypesList.raw = {
  EDUCATIONAL_INSTITUTION: 'Education institution',
  GOVERNMENT_AGENCY: 'Government agency',
  NONPROFIT: 'Nonprofit',
  PARTNERSHIP: 'Partnership',
  PRIVATELY_HELD: 'Privately held',
  FAMILY_BUSINESS: 'Family business',
  PUBLIC_COMPANY: 'Public company',
  SELF_EMPLOYED: 'Self employed',
  SOLE_PROPRIETORSHIP: 'Sole proprietorship',
};
companyTypesList.mapping = { ...companyTypesList.raw };
companyTypesList.selectArrayOptions = Object.keys(companyTypesList.mapping)
  .map(k => ({ key: k, text: companyTypesList.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const orderLineStatus = {
  ORDERED: 'Ordered',
  SHIPPED: 'Shipped',
  RECEIVED: 'Received',
};
orderLineStatus.selectArrayOptions = Object.keys(orderLineStatus).map(k => ({
  key: k,
  text: orderLineStatus[k],
}));

export const languages = {};
languages.raw = {
  en: 'English',
  de: 'German',
  es: 'Spanish',
  fr: 'French',
};
languages.mapping = { ...languages.raw };
languages.selectArrayOptions = Object.keys(languages.mapping)
  .map(k => ({ key: k, text: languages.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const badges = [
  { name: 'Supply Chain Transparency', value: 'SUPPLY_CHAIN_TRANSPARENCY' },
  { name: 'Fair Payment', value: 'FAIR_PAYMENT' },
  { name: 'Fair Working Conditions', value: 'FAIR_WORKING_CONDITIONS' },
  { name: 'Fair Trade Materials', value: 'FAIR_TRADE_MATERIALS' },
  { name: 'Social Engagement', value: 'SOCIAL_ENGAGEMENT' },
  { name: 'Sustainable Materials', value: 'SUSTAINABLE_MATERIALS' },
  { name: 'No Hazardous Chemicals', value: 'NO_HAZARDOUS_CHEMICALS' },
  { name: 'Low Water Usage', value: 'LOW_WATER_USAGE' },
  { name: 'Climate Friendly', value: 'CLIMATE_FRIENDLY' },
  { name: 'Circularity', value: 'CIRCULARITY' },
  { name: 'Environmental Engagement', value: 'ENVIRONMENTAL_ENGAGEMENT' },
];

export const environmentClaimId = 'PVORNN6M33LU50BOLD';
export const socialEngagementClaimId = 'L0TBUPMHZML19JT99H';

export const shippingMethods = [
  { name: 'Sea', value: 'SEA' },
  { name: 'Land', value: 'LAND' },
  { name: 'Air', value: 'AIR' },
  { name: 'Express', value: 'EXPRESS' },
];

export const CERTIFICATE_CREATION_INIT_STEP = [
  {
    index: 0,
    title: 'certificate.add.modal.steps1',
  },
  {
    index: 1,
    title: 'certificate.add.modal.steps2',
  },
  {
    index: 2,
    title: 'certificate.add.modal.steps3',
  },
];

// Sourced from @retracedgmbh/modules so this dashboard, frontend-v2 and the
// backend's `z.enum(QuestionnaireStatuses)` on create/update share a single
// source of truth.
export const QUESTIONNAIRE_STATES = QUESTIONNAIRE_STATUS;

export const questionnaireStates = {};
questionnaireStates.raw = QUESTIONNAIRE_STATES;
questionnaireStates.mapping = { ...questionnaireStates.raw };
questionnaireStates.selectArray = arrayize(questionnaireStates.mapping);
questionnaireStates.selectArrayOptions = Object.keys(
  questionnaireStates.mapping,
).map(k => ({
  key: k,
  text: questionnaireStates.mapping[k],
}));

export const QUESTIONNAIRE_REQUEST_STATES = {
  OPEN: 'Open',
  IN_REVIEW: 'In Review',
  COMPLETED: 'Completed',
  REQUEST_CHANGES: 'Request Changes',
};

export const questionnaireRequestStates = {};
questionnaireRequestStates.raw = QUESTIONNAIRE_REQUEST_STATES;
questionnaireRequestStates.mapping = { ...questionnaireRequestStates.raw };
questionnaireRequestStates.selectArray = arrayize(
  questionnaireRequestStates.mapping,
);
questionnaireRequestStates.selectArrayOptions = Object.keys(
  questionnaireRequestStates.mapping,
).map(k => ({
  key: k,
  text: questionnaireRequestStates.mapping[k],
}));
questionnaireRequestStates.enumMapping =
  questionnaireRequestStates.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const PRODUCT_AND_TRANSACTION_CERTIFICATE_STEPS = [
  {
    index: 3,
    title: 'certificate.add.modal.steps4',
  },
];

export const relationshipTypes = {
  SUBCONTRACTOR: 'Subcontractor',
  FACILITY: 'Facility',
  BRANCH: 'Branch',
};

export const relationships = {};
relationships.raw = {
  SUBCONTRACTOR: 'Subcontractor',
  FACILITY: 'Facility',
  BRANCH: 'Branch',
};
relationships.mapping = { ...relationships.raw };
relationships.selectArray = arrayize(relationships.mapping);
relationships.selectArrayOptions = Object.keys(relationships.mapping).map(
  k => ({
    key: k,
    text: relationships.mapping[k],
  }),
);

export const certificationTypes = {};
certificationTypes.raw = {
  MEMBERSHIP: 'Membership',
  PRODUCT: 'Product',
  TRANSACTION: 'Transaction',
  COMPANY: 'Company',
  SCOPE: 'Scope',
};
certificationTypes.mapping = { ...certificationTypes.raw };
certificationTypes.selectArray = arrayize(certificationTypes.mapping);
certificationTypes.selectArrayOptions = Object.keys(certificationTypes.raw)
  .map(k => ({ key: k, text: certificationTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
certificationTypes.enumMapping = certificationTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const claimTypes = {};
claimTypes.raw = {
  BADGE: 'Badge',
  PAYMENT: 'Payment',
  ...certificationTypes.raw,
};
claimTypes.mapping = { ...claimTypes.raw };
claimTypes.selectArray = arrayize(claimTypes.mapping);
claimTypes.selectArrayOptions = Object.keys(claimTypes.raw)
  .map(k => ({ key: k, text: claimTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
claimTypes.enumMapping = claimTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const claimStatuses = {};
claimStatuses.raw = {
  APPROVED: 'Approved',
  REQUESTED: 'In review',
  DRAFT: 'Rejected',
  NOT_VERIFIABLE: 'Non-Verifiable',
};
claimStatuses.mapping = { ...claimStatuses.raw };
claimStatuses.selectArray = arrayize(claimStatuses.mapping);
claimStatuses.selectArrayOptions = Object.keys(claimStatuses.raw)
  .map(k => ({ key: k, text: claimStatuses.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
claimStatuses.enumMapping = Object.keys(claimStatuses.raw).reduce(
  (acc, obj) => ({ ...acc, [obj]: obj }),
  {},
);

export const claimExpirationStatuses = {};
claimExpirationStatuses.raw = {
  EXPIRED: 'Expired',
  NON_EXPIRED: 'Non-expired',
};
claimExpirationStatuses.selectArrayOptions = Object.keys(
  claimExpirationStatuses.raw,
)
  .map(k => ({ key: k, text: claimExpirationStatuses.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
claimExpirationStatuses.enumMapping = Object.keys(
  claimExpirationStatuses.raw,
).reduce((acc, obj) => ({ ...acc, [obj]: obj }), {});

export const claimArchivedStatuses = {};
claimArchivedStatuses.raw = {
  0: 'Active',
  1: 'Archived',
};
claimArchivedStatuses.selectArrayOptions = Object.keys(
  claimArchivedStatuses.raw,
)
  .map(k => ({ key: k, text: claimArchivedStatuses.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
claimArchivedStatuses.enumMapping = Object.keys(
  claimArchivedStatuses.raw,
).reduce((acc, obj) => ({ ...acc, [Number(obj)]: obj }), {});

export const claimRemovedStatuses = {};
claimRemovedStatuses.raw = {
  0: 'Active',
  1: 'Removed',
};
claimRemovedStatuses.selectArrayOptions = Object.keys(claimRemovedStatuses.raw)
  .map(k => ({ key: k, text: claimRemovedStatuses.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
claimRemovedStatuses.enumMapping = Object.keys(claimRemovedStatuses.raw).reduce(
  (acc, obj) => ({ ...acc, [Number(obj)]: obj }),
  {},
);

export const CLAIM_ACTION_TRIGGERS = {
  RESTORING: 'Restoring',
  UN_ARCHIVING: 'Un Archiving',
  ARCHIVING: 'Archiving',
  REMOVING: 'Removing',
};

export const materialTypes = {};
materialTypes.raw = {
  BLEND: 'Blend',
  RAW_MATERIAL: 'Raw Material',
};
materialTypes.mapping = { ...materialTypes.raw };
materialTypes.selectArray = arrayize(materialTypes.mapping);

export const RETRACED_ADMIN_ROLES_ENUM = {
  RETRACED_ADMIN: 'RETRACED_ADMIN',
  RETRACED_SALES: 'RETRACED_SALES',
  RETRACED_PRODUCT_DEVELOPMENT: 'RETRACED_PRODUCT_DEVELOPMENT',
  RETRACED_CUSTOMER_SUCCESS: 'RETRACED_CUSTOMER_SUCCESS',
  // Was missing here even after retracedRoles.raw (below) was fixed for the
  // same gap — any isRetracedAdmin/staff check built on this enum silently
  // treated a RETRACED_MARKETING user as not-staff.
  RETRACED_MARKETING: 'RETRACED_MARKETING',
};

export const companyRoles = {};
// Keyed by the real `iam_roles.key` — sent as-is to the server, which no
// longer translates a legacy bucket string.
companyRoles.raw = {
  'company-admin': 'Company Owner',
  'company-creator': 'Employee',
};
companyRoles.selectArrayOptions = Object.keys(companyRoles.raw)
  .map(k => ({ key: k, text: companyRoles.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const retracedRoles = {};

// Keyed by the real `iam_roles.key` — sent as-is to the server, which no
// longer translates a legacy bucket string.
retracedRoles.raw = {
  'retraced-admin': 'Retraced Admin',
  'retraced-sales': 'Retraced Sales',
  'retraced-product-development': 'Retraced Product Development',
  'retraced-customer-success': 'Retraced Customer Success',
  // Accepted by the server (`USER_ROLE_VALUES` in
  // `modules/companies/contracts/schemas/create-user-company.ts`) but was
  // missing here — a user holding it rendered blank, and any role picker
  // built off `retracedRoles`/`userRoles` silently dropped it as a choice.
  'retraced-marketing': 'Retraced Marketing',
};
retracedRoles.mapping = { ...retracedRoles.raw };
retracedRoles.selectArrayOptions = Object.keys(retracedRoles.raw)
  .map(k => ({ key: k, text: retracedRoles.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const userRoles = {};

userRoles.raw = {
  ...companyRoles.raw,
  ...retracedRoles.raw,
  ADMIN: 'Admin',
};
userRoles.mapping = { ...userRoles.raw };
userRoles.selectArray = arrayize(userRoles.mapping);
userRoles.selectArrayOptions = Object.keys(userRoles.raw)
  .map(k => ({ key: k, text: userRoles.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const genders = {};
genders.raw = {
  MALE: 'Male',
  FEMALE: 'Female',
  UNISEX: 'Unisex',
};
genders.mapping = { ...genders.raw };
genders.selectArray = arrayize(genders.mapping);
genders.selectArrayOptions = Object.keys(genders.raw)
  .map(k => ({
    key: k,
    text: genders.raw[k],
  }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const filterBoolean = {};
filterBoolean.raw = {
  1: 'Yes',
  0: 'No',
};
filterBoolean.mapping = { ...filterBoolean.raw };
filterBoolean.selectArray = arrayize(filterBoolean.mapping);
filterBoolean.selectArrayOptions = Object.keys(filterBoolean.raw)
  .map(k => ({
    key: k,
    text: filterBoolean.raw[k],
  }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const filterBooleanReverse = {};
filterBooleanReverse.raw = {
  1: 'No',
  0: 'Yes',
};
filterBooleanReverse.mapping = { ...filterBooleanReverse.raw };
filterBooleanReverse.selectArray = arrayize(filterBooleanReverse.mapping);
filterBooleanReverse.selectArrayOptions = Object.keys(filterBooleanReverse.raw)
  .map(k => ({
    key: k,
    text: filterBooleanReverse.raw[k],
  }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const documentTypes = {};

documentTypes.raw = [
  {
    name: 'Mission Statement',
    value: 'MISSION_STATEMENT',
    documentType: 'Statement',
    impactArea: 'Governance',
  },
  {
    name: 'Code of Ethics',
    value: 'CODE_OF_ETHICS',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Corporate Social Responsibility',
    value: 'CORPORATE_SOCIAL_RESPONSIBILITY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Whistleblower Policy',
    value: 'WHISTLEBLOWER_POLICY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Risk Assessment',
    value: 'RISK_ASSESSMENT',
    documentType: 'Assessment',
    impactArea: 'Governance',
  },
  {
    name: 'Company Register Excerpt',
    value: 'COMPANY_REGISTER_EXCERPT',
    documentType: 'Excerpt',
    impactArea: 'Governance',
  },
  {
    name: 'Financial Report',
    value: 'FINANCIAL_REPORT',
    documentType: 'Report',
    impactArea: 'Governance',
  },
  {
    name: 'Sustainability/CSR/Impact Report',
    value: 'SUSTAINABILITY_CSR_IMPACT_REPORT',
    documentType: 'Report',
    impactArea: 'Governance',
  },
  {
    name: 'Tax Payment',
    value: 'TAX_PAYMENT',
    documentType: 'Excerpt',
    impactArea: 'Governance',
  },
  {
    name: 'Political Contribution Policy',
    value: 'POLITICAL_CONTRIBUTION_POLICY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Code of Conduct',
    value: 'CODE_OF_CONDUCT',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Sustainability Sourcing Policy',
    value: 'SUSTAINABILITY_SOURCING_POLICY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Sustainability Handbook',
    value: 'SUSTAINABILITY_HANDBOOK',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'California Transparency in Supply Chains Act Disclosure',
    value: 'CALIFORNIA_TRANSPARENCY_IN_SUPPLY_CHAINS_ACT_DISCLOSURE',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Conflict of Interest Policy',
    value: 'CONFLICT_OF_INTEREST_POLICY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Global Antitrust and Fair Competition Policy',
    value: 'GLOBAL_ANTITRUST_AND_FAIR_COMPETITION_POLICY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Privacy Policy',
    value: 'PRIACY_POLICY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'GDRP Policy',
    value: 'GDRP_POLICY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Trade Compliance Policy',
    value: 'TRADE_COMPLIANCE_POLICY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Anti Corruption Policy',
    value: 'ANTI_CORRUPTION_POLICY',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Distribution License',
    value: 'DISTRIBUTION_LICENSE',
    documentType: 'License',
    impactArea: 'Governance',
  },
  {
    name: 'Data Protection Policy',
    value: 'DATA_PROTECTION_POLICY',
    documentType: 'POLICY',
    impactArea: 'GOVERNANCE',
  },
  {
    name: 'Fire Safety Report',
    value: 'FIRE_SAFETY_REPORT',
    documentType: 'REPORT',
    impactArea: 'GOVERNANCE',
  },
  {
    name: 'Building Security Report',
    value: 'BUILDING_SECURITY_REPORT',
    documentType: 'REPORT',
    impactArea: 'GOVERNANCE',
  },
  {
    name: 'Electrical Inspection and Testing Report',
    value: 'ELECTRICAL_INSPECTION_AND_TESTING_REPORT',
    documentType: 'REPORT',
    impactArea: 'GOVERNANCE',
  },
  {
    name: 'Pressure Vessel Inspection Report',
    value: 'PRESSURE_VESSEL_INSPECTION_REPORT',
    documentType: 'REPORT',
    impactArea: 'GOVERNANCE',
  },
  {
    name: 'Pension Plan',
    value: 'PENSION_PLAN',
    documentType: 'Agreement',
    impactArea: 'Workers',
  },
  {
    name: 'Insurance',
    value: 'INSURANCE',
    documentType: 'Agreement',
    impactArea: 'Workers',
  },
  {
    name: 'Human Rights Policy',
    value: 'HUMAN_RIGHTS_POLICY',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Policy on Working Conditions',
    value: 'POLICY_ON_WORKING_CONDITIONS',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Policy on Working Conditions and Human Rights',
    value: 'POLICY_ON_WORKING_CONDITIONS_AND_HUMAN_RIGHTS',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Child Labor and Young Workers Policy',
    value: 'CHILD_LABOR_AND_YOUNG_WORKERS_POLICY',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Wages and Benefits Policy',
    value: 'WAGES_AND_BENEFITS_POLICY',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Working Hours Policy',
    value: 'WORKING_HOURS_POLICY',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Modern Slavery Policy',
    value: 'MODERN_SLAVERY_POLICY',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Paycheck',
    value: 'PAYCHECK',
    type: 'EXCERPT',
    impactArea: 'WORKERS',
  },
  {
    name: 'Payment Slip',
    value: 'PAYMENT_SLIP',
    type: 'EXCERPT',
    impactArea: 'WORKERS',
  },
  {
    name: 'Harassment and non-discrimination Policy',
    value: 'HARASSMENT_AND_NON_DISCRIMINATION_POLICY',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Freedom of Association and Collective Bargaining Policy',
    value: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING_POLICY',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Policies on pay and performance issues',
    value: 'POLICIES_ON_PAY_AND_PERFORMANCE_ISSUES',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Policies on benefits, training and leave',
    value: 'POLICIES_ON_BENEFITS_TRAINING_AND_LEAVE',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Employee Handbook',
    value: 'EMPLOYEE_HANDBOOK',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Parental Leave Policy',
    value: 'PARENTAL_LEAVE_POLICY',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Complaint Mechanism',
    value: 'COMPLAIN_MECHANISM',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Employee Satisfaction Survey',
    value: 'EMPLOYEE_SATISFACTION_SURVEY',
    documentType: 'Survey',
    impactArea: 'Workers',
  },
  {
    name: 'Employee Engagement Survey',
    value: 'EMPLOYEE_ENGAGEMENT_SURVEY',
    documentType: 'Survey',
    impactArea: 'Workers',
  },
  {
    name: 'Health and Safety Policy',
    value: 'HEALTH_AND_SAFETY_POLICY',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Slavery and Human Trafficking',
    value: 'SLAVERY_AND_HUMAN_TRAFFICKING',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Employment Contract/Agreement',
    value: 'EMPLOYMENT_CONTRACT_AGREEMENT',
    documentType: 'Agreement',
    impactArea: 'Workers',
  },
  {
    name: 'Social Insurance Proof',
    value: 'SOCIAL_INSURANCE_PROOF',
    documentType: 'Excerpt',
    impactArea: 'Workers',
  },
  {
    name: 'Salary Excerpt',
    value: 'SALARY_EXCERPT',
    documentType: 'Excerpt',
    impactArea: 'Workers',
  },
  {
    name: 'Fire Safety Regulations',
    value: 'FIRE_SAFETY_REGULATIONS',
    documentType: 'Policy',
    impactArea: 'Workers',
  },
  {
    name: 'Diversity Improvement Goals',
    value: 'DIVERSITY_IMPROVEMENT_GOALS',
    documentType: 'Goal',
    impactArea: 'Community',
  },
  {
    name: 'NGO Membership',
    value: 'NGO_MEMBERSHIP',
    documentType: 'Agreement',
    impactArea: 'Community',
  },
  {
    name: 'NGO Partnership',
    value: 'NGO_PARTNERSHIP',
    documentType: 'Agreement',
    impactArea: 'Community',
  },
  {
    name: 'Donations Commitment',
    value: 'DONATIONS_COMMITMENT',
    documentType: 'Agreement',
    impactArea: 'Community',
  },
  {
    name: 'Supplier Code of Conduct',
    value: 'SUPPLIER_CODE_OF_CONDUCT',
    documentType: 'Policy',
    impactArea: 'Community',
  },
  {
    name: 'Charitable Contribution',
    value: 'CHARTIABLE_CONTRIBUTION',
    documentType: 'Excerpt',
    impactArea: 'Community',
  },
  {
    name: 'Donation Slip',
    value: 'DONATION_SLIP',
    documentType: 'Excerpt',
    impactArea: 'Community',
  },
  {
    name: 'Subcontracting Policy',
    value: 'SUBCONTRACTING_POLICY',
    documentType: 'Policy',
    impactArea: 'Community',
  },
  {
    name: 'Conflict Minerals',
    value: 'CONFLICTING_MINERALS',
    documentType: 'Policy',
    impactArea: 'Community',
  },
  {
    name: 'Energy Efficiency Improvements',
    value: 'ENERGY_EFFICIENCY_IMPROVEMENTS',
    documentType: 'Goal',
    impactArea: 'Environment',
  },
  {
    name: 'Water Efficiency Improvements',
    value: 'WATER_EFFICIENCY_IMPROVEMENTS',
    documentType: 'Goal',
    impactArea: 'Environment',
  },
  {
    name: 'Waste Reduction Program',
    value: 'WASTE_REDUCTION_PROGRAM',
    documentType: 'Goal',
    impactArea: 'Environment',
  },
  {
    name: 'Environmental Policy',
    value: 'ENVIRONMENTAL_POLICY',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Carbon Neutrality',
    value: 'CARBON_NEUTRALITY',
    documentType: 'Report',
    impactArea: 'Environment',
  },
  {
    name: 'Business Travel Policy',
    value: 'BUSINESS_TRAVEL_POLICY',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'End-of-life Reclamation Program',
    value: 'END_OF_LIFE_RECLAMATION_PROGRAM',
    documentType: 'Agreement',
    impactArea: 'Environment',
  },
  {
    name: 'Ethical Marketing Policy',
    value: 'ETHICAL_MARKETING_POLICY',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Advertisement Policy',
    value: 'ADVERTISEMENT_POLICY',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Customer Engagement Policy',
    value: 'CUSTOMER_ENGAGEMENT_POLICY',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'REACH Declaration',
    value: 'REACH_DECLARATION',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Guideline for Waste Management',
    value: 'GUIDELINE_FOR_WASTE_MANAGEMENT',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Guideline for Working with Chemical and Toxic Substances',
    value: 'GUIDELINE_FOR_WORKING_WITH_CHEMICAL_AND_TOXIC_SUBSTANCES',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Guideline for Wastewater Treatment',
    value: 'GUIDELINE_FOR_WASTEWATER_TREATMENT',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Laboratory Tests',
    value: 'LABORATORY_TESTS',
    documentType: 'Test Result',
    impactArea: 'Environment',
  },
  {
    name: 'Science Based Targets',
    value: 'SCIENCE_BASED_TARGETS',
    documentType: 'Agreement',
    impactArea: 'Environment',
  },
  {
    name: 'Business License',
    value: 'BUSINESS_LICENSE',
    documentType: 'License',
    impactArea: 'Governance',
  },
  {
    name: 'Manufacturing Restricted Substances List (MRSL)',
    value: 'MANUFACTURING_RESTRICTED_SUBSTANCES_LIST',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Restricted Substances List (RSL)',
    value: 'RESTRICTED_SUBSTANCES_LIST',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Ethical Sourcing Standard',
    value: 'ETHICAL_SOURCING_STANDARD',
    documentType: 'Policy',
    impactArea: 'Environment',
  },
  {
    name: 'Intermediary Bank Certificate',
    value: 'INTERMEDIARY_BANK_CERTIFICATE',
    documentType: 'License',
    impactArea: 'Governance',
  },
  {
    name: 'Bank Certificate',
    value: 'BANK_CERTIFICATE',
    documentType: 'License',
    impactArea: 'Governance',
  },
  {
    name: 'Export License',
    value: 'EXPORT_LICENSE',
    documentType: 'License',
    impactArea: 'Governance',
  },
  {
    name: 'Quality Guideline',
    value: 'QUALITY_GUIDELINE',
    documentType: 'Agreement',
    impactArea: 'Governance',
  },
  {
    name: 'FAMA Licence',
    value: 'FAMA_LICENCE',
    documentType: 'License',
    impactArea: 'Governance',
  },
  {
    name: 'Declaration of origin',
    value: 'DECLARATION_OF_ORIGIN',
    documentType: 'Statement',
    impactArea: 'Governance',
  },
  {
    name: 'Waste Water Report',
    value: 'WASTE_WATER_REPORT',
    documentType: 'Report',
    impactArea: 'Environment’',
  },
  {
    name: 'Sludge Report',
    value: 'SLUDGE_REPORT',
    documentType: 'Report',
    impactArea: 'Environment’',
  },
  {
    name: 'Raw Material Ban',
    value: 'RAW_MATERIAL_BAN',
    documentType: 'Policy',
    impactArea: 'Governance',
  },
  {
    name: 'Consent Declaration',
    value: 'CONSENT_DECLARATION',
    documentType: 'Agreement',
    impactArea: 'Governance',
  },
];

documentTypes.mapping = documentTypes.raw
  .sort((a, b) => a.name.localeCompare(b.name))
  .reduce((acc, obj) => ({ ...acc, [obj.value]: obj.name }), {});
documentTypes.selectArray = Object.keys(documentTypes.mapping).map(k => ({
  key: k,
  text: documentTypes.mapping[k],
}));

export const auditPresets = {};
auditPresets.raw = {
  GREEN_BUTTON_AUDIT: 'Grüner Knopf',
  OCS_AUDIT: 'Organic Content Standard (OCS)',
  ELEVATE: 'Elevate',
  BETTER_WORK: 'Better Work',
  SEDEX_SMETA: 'Sedex (SMETA)',
  FAIR_WEAR_FOUNDATION: 'Fair Wear Foundation',
  BSCI: 'BSCI',
  ETI: 'ETI',
  ICS: 'ICS',
  FLA: 'FLA',
  ISO_26000: 'ISO 26000',
  OHSAS_18001: 'OHSAS 18001',
  SA8000: 'SA8000',
  WRAP: 'WRAP',
  CONTROL_UNION_FAIR_CHOICE_AUDIT: 'Control Union Fair Choice',
  GOTS: 'GOTS',
  AWS_ALLIANCE_FOR_WATER_STEWARDSHIP: 'AWS - Alliance For Water Stewardship',
  EWS_EUROPEAN_WATER_STEWARDSHIP: 'EWS - European Water Stewardship',
  HIGG_FEM_HIGG_FACILITY_ENVIRONMENTAL_MODULE:
    'HIGG FEM - Higg Facility Environmental Module',
  SFP_SUSTAINABLE_FIBRE_PROGRAMME: 'SFP - Sustainable Fibre Programme',
  ARS_TINCTORIA: 'Ars Tinctoria',
  EUROFINS: 'Eurofins',
  BLUESIGN: 'Bluesign',
  BRACHI_TESTING_SERVICES: 'Brachi Testing Services',
  BUREAU_VERITAS: 'Bureau Veritas',
  UNITED_TESTING_SERVICES: 'United Testing Services',
  CENTROCOT: 'Centrocot',
  CENTRO_TESSILE_SERICO_SOSTENIBLE: 'Centro Tessile Serico Sostenibile',
  PETERSON_CONTROL_UNION: 'Peterson Control Union',
  OEKO_TEX: 'Oeko-Tex',
  ELLEACITI: 'ElleACiTi',
  FITI: 'Fiti',
  HOHENSTEIN: 'Hoheinstein',
  ICEC: 'ICEC',
  IMPAQ: 'IMPAQ',
  INTERTEK: 'Intertek',
  MTS: 'MTS',
  NIMKARTEK: 'NIMKARTEK',
  SGS: 'SGS',
  SCIVERA: 'Scivera',
  SUSTAINABLE_TEXTILE_SOLUTIONS: 'Sustainable Textile Solutions',
  TEXANLAB: 'Texanlab',
  TESTEX: 'Testex',
  TOXSERVICES: 'Toxservices',
  TUV_RHEINLAND: 'TÜV Rheinland',
  TUV_SUD: 'TÜV Süd',
  UL: 'UL',
  HIGG_FSLM_HIGG_FACILITY_SOCIAL_LABOR_MODULE:
    'Higg FSLM - Higg Facility Social Labour Module',
  FACTORY_VISIT: 'Factory Visit',
  SLCP_CONVERGED_ASSESSMENT_FRAMEWORK: 'SLCP - Converged Assessment Framework',
  ICTI_ETHICAL_TOY_PROGRAM: 'ICTI Ethical Toy Program',
  AMFORI_BEPI: 'amfori BEPI',
  IMPACT_PROGRAM: 'IMPACT Program',
};
auditPresets.mapping = { ...auditPresets.raw };
auditPresets.selectArray = Object.keys(auditPresets.mapping)
  .map(k => ({ key: k, text: auditPresets.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const legacyAuditTypeCategories = {};
legacyAuditTypeCategories.raw = {
  CHEMICAL_AUDIT: 'Chemical Audit',
  ENVIRONMENTAL_AUDIT: 'Environmental Audit',
  SOCIAL_AUDIT: 'Social Audit',
  SOCIAL_ENVIRONMENTAL_CHEMICAL_AUDIT: 'Social, Environmental & Chemical Audit',
};

legacyAuditTypeCategories.mapping = { ...legacyAuditTypeCategories.raw };
legacyAuditTypeCategories.selectArray = Object.keys(
  legacyAuditTypeCategories.mapping,
);
legacyAuditTypeCategories.selectArrayOptions = Object.keys(
  legacyAuditTypeCategories.raw,
)
  .map(k => ({ key: k, text: legacyAuditTypeCategories.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
legacyAuditTypeCategories.enumMapping =
  legacyAuditTypeCategories.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const STANDARD_TYPES_ENUM = {
  CERTIFICATE: 'CERTIFICATE',
  COMPANY_DOCUMENT: 'COMPANY_DOCUMENT',
  MEMBERSHIP: 'MEMBERSHIP',
  AUDIT: 'AUDIT',
};

export const standardTypes = {};
standardTypes.raw = {
  CERTIFICATE: 'Certificate',
  COMPANY_DOCUMENT: 'Document',
  MEMBERSHIP: 'Membership',
};
standardTypes.mapping = { ...standardTypes.raw };

export const assessmentFormRequestStatuses = {};
assessmentFormRequestStatuses.raw = {
  totalApproved: 'Approved',
  totalInReview: 'In Review',
  totalDenied: 'Denied',
  totalMissing: 'Not answered yet',
};

assessmentFormRequestStatuses.enumMapping = {
  ...assessmentFormRequestStatuses.raw,
};
assessmentFormRequestStatuses.mapping = Object.keys(
  assessmentFormRequestStatuses.raw,
).reduce((acc, obj) => ({ ...acc, [obj]: obj }), {});
assessmentFormRequestStatuses.selectArrayOptions = Object.keys(
  assessmentFormRequestStatuses.raw,
)
  .map(k => ({ key: k, text: assessmentFormRequestStatuses.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const assessmentFormQuestionStatuses = {};
assessmentFormQuestionStatuses.raw = {
  APPROVED: 'Approved',
  DENIED: 'Denied',
  INREVIEW: 'In Review',
  MISSING: 'Not answered yet',
};

// Must be renamed as .mapping
assessmentFormQuestionStatuses.enumMapping = {
  ...assessmentFormQuestionStatuses.raw,
};
// Must be renamed as .enumMapping
assessmentFormQuestionStatuses.mapping = Object.keys(
  assessmentFormQuestionStatuses.raw,
).reduce((acc, obj) => ({ ...acc, [obj]: obj }), {});

export const shopComponents = {};
shopComponents.raw = {
  BUTTON_VERIFIED: 'Retraced button verified',
  BUTTON_TRANSPARENCY_REPORT: 'Retraced button transparency report',
  CARDS: 'Retraced cards',
  ICONS: 'Retraced icons',
  ICONS_WITH_DESCRIPTION: 'Retraced icons with description',
};
shopComponents.mapping = { ...shopComponents.raw };
shopComponents.selectArrayOptions = Object.keys(shopComponents.raw)
  .map(k => ({ key: k, text: shopComponents.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
shopComponents.enumMapping = shopComponents.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const shopComponentsScript = {};
shopComponentsScript.raw = {
  BUTTON_VERIFIED: 'button-verified.js',
  BUTTON_TRANSPARENCY_REPORT: 'button-transparency-report.js',
  CARDS: 'cards.js',
  ICONS: 'icons.js',
  ICONS_WITH_DESCRIPTION: 'icons-with-description.js',
};
shopComponentsScript.mapping = { ...shopComponentsScript.raw };

// API only accepts following extensions
// If another extension is added, the API must be patched also
export const FILE_EXTENSIONS = {
  IMAGE: [
    '.jpg',
    '.bmp',
    '.jpeg',
    '.png',
    '.heic',
    '.gif',
    '.svg',
    '.webp',
    '.tiff',
  ],
  EXCEL: ['.xls', '.xlsx'],
  VIDEO: ['.mp4', '.webm'],
  DOCUMENT: [
    '.doc',
    '.docx',
    '.pdf',
    '.xls',
    '.csv',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.rtf',
  ],
  BASIC_IMAGE: ['.jpg', '.bmp', '.jpeg', '.png', '.gif', '.webp', '.tiff'], // Used ATM for company images as both SVG and HEIC are not working in static mapbox image
};

export const FILE_EXTENSIONS_ICONS = {
  IMAGE: 'fa-file-image',
  EXCEL: 'fa-file-excel',
  VIDEO: 'fa-file-video',
  DOCUMENT: 'fa-file-alt',
  BASIC_IMAGE: 'fa-file-image',
};

export const UPDATED_FILE_EXTENSIONS = {
  IMAGE: {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/bmp': ['.bmp'],
    'image/png': ['.png'],
    'image/heic': ['.heic'],
    'image/gif': ['.gif'],
    'image/svg+xml': ['.svg'],
    'image/webp': ['.webp'],
    'image/tiff': ['.tiff'],
  },
  EXCEL: {
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
    ],
  },
  VIDEO: {
    'video/mp4': ['.mp4'],
    'video/webm': ['.webm'],
  },
  DOCUMENT: {
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
      '.docx',
    ],
    'application/pdf': ['.pdf'],
    'application/vnd.ms-excel': ['.xls'],
    'text/csv': ['.csv'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
    ],
    'application/vnd.ms-powerpoint': ['.ppt'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      ['.pptx'],
  },
  BASIC_IMAGE: {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/bmp': ['.bmp'],
    'image/png': ['.png'],
    'image/gif': ['.gif'],
    'image/webp': ['.webp'],
    'image/tiff': ['.tiff'],
  },
};

export const productItemFieldTypes = {};
export const productFieldTypes = {};
export const commonFieldTypes = {};
export const allFieldTypes = {};

commonFieldTypes.raw = {
  SELECT: 'Select', // Select field
  SHORT_TEXT: 'Short text', // Text field
  LONG_TEXT: 'Long text', // Textarea
  NUMBER: 'Number', // Textfield number
  NUMBER_UOM: 'Number with UOM', // Textfield number with UOM,
  MULTI_SELECT: 'Multi select',
  DATE: 'date',
  DATE_RANGE: 'Date range',
  YEAR_PICKER: 'Year picker',
  CHECKBOX: 'checkbox',
};

productItemFieldTypes.raw = {
  NUMBER_UOM_PERCENTAGE: 'Number with UOM and percentage', // Textfield number with uom with percentage calculation
};

productFieldTypes.raw = {
  NUMBER_UOM_TEXT: 'Number with free text UOM',
};

productItemFieldTypes.mapping = {
  ...commonFieldTypes.raw,
  ...productItemFieldTypes.raw,
};
productItemFieldTypes.selectArrayOptions = Object.keys(
  productItemFieldTypes.mapping,
)
  .map(k => ({ key: k, text: productItemFieldTypes.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
productItemFieldTypes.enumMapping =
  productItemFieldTypes.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

productFieldTypes.mapping = {
  ...commonFieldTypes.raw,
  ...productFieldTypes.raw,
};
productFieldTypes.selectArrayOptions = Object.keys(productFieldTypes.mapping)
  .map(k => ({ key: k, text: productFieldTypes.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
productFieldTypes.enumMapping = productFieldTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

allFieldTypes.mapping = {
  ...commonFieldTypes.raw,
  ...productFieldTypes.raw,
  ...productItemFieldTypes.raw,
};
allFieldTypes.selectArrayOptions = Object.keys(allFieldTypes.mapping)
  .map(k => ({ key: k, text: allFieldTypes.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
allFieldTypes.enumMapping = allFieldTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const formCustomElements = {};
formCustomElements.raw = {
  SHORT_TEXT: 'Short text', // Text field
  LONG_TEXT: 'Long text', // Textarea
  NUMBER: 'Number', // Textfield number
  NUMBER_UOM: 'Number with UOM', // Textfield number
  MULTIPLE_CHOICE: 'Multiple choice', // Radio group
  CHECK_BOXES: 'Check box', // Checkbox
  SELECT: 'Select Option', // Dropdown
  ASSET_LINK: 'Documents',
  YES_NO: 'Yes/No',
  YES_NO_THEN: 'Yes/No then', // If yes then another file upload or text or asset link question
};

formCustomElements.mapping = { ...formCustomElements.raw };
formCustomElements.selectArrayOptions = Object.keys(formCustomElements.raw)
  .map(k => ({ key: k, text: formCustomElements.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
formCustomElements.enumMapping = formCustomElements.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
formCustomElements.mappingArray = Object.keys(formCustomElements.raw).map(
  k => k,
);

export const supplierQuestionnaireAnswerTypes = {};
supplierQuestionnaireAnswerTypes.raw = {
  SHORT_TEXT: 'Short text', // Text field
  LONG_TEXT: 'Long text', // Textarea
  NUMBER: 'Number', // Textfield number
  NUMBER_UOM: 'Number with UOM', // Textfield number
  MULTIPLE_CHOICE: 'Multiple choice', // Checkbox
  CHECK_BOXES: 'Multiple choice', // Checkbox
  CHECK_BOX: 'Check box', // Checkbox
  SELECT: 'Select Option', // Dropdown
  DOCUMENTS: 'Documents',
  AUDIT: 'Audit',
  CERTIFICATE: 'Certificate',
  YES_NO: 'Yes/No',
  DATE: 'Date',
  BOOLEAN: 'Boolean',
};

supplierQuestionnaireAnswerTypes.mapping = {
  ...supplierQuestionnaireAnswerTypes.raw,
};
supplierQuestionnaireAnswerTypes.selectArrayOptions = Object.keys(
  supplierQuestionnaireAnswerTypes.raw,
)
  .map(k => ({ key: k, text: supplierQuestionnaireAnswerTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
supplierQuestionnaireAnswerTypes.enumMapping =
  supplierQuestionnaireAnswerTypes.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
supplierQuestionnaireAnswerTypes.mappingArray = Object.keys(
  supplierQuestionnaireAnswerTypes.raw,
).map(k => k);

export const customQuestionTypesIcons = {
  SHORT_TEXT: 'fal fa-text',
  LONG_TEXT: 'fal fa-paragraph',
  NUMBER: 'fal fa-sort-numeric-up',
  NUMBER_UOM: 'fal fa-image',
  MULTIPLE_CHOICE: 'fal fa-dot-circle',
  CHECK_BOXES: 'fal fa-tasks',
  SELECT: 'fal fa-caret-down',
  ASSET_LINK: 'fal fa-file-alt',
  YES_NO: 'fal fa-toggle-on',
};

export const legacyFormCustomElements = {};
legacyFormCustomElements.raw = {
  ...formCustomElements.raw,
  FILE_UPLOAD: 'File upload', // General file upload
};
legacyFormCustomElements.mapping = { ...legacyFormCustomElements.raw };
legacyFormCustomElements.selectArrayOptions = Object.keys(
  legacyFormCustomElements.raw,
)
  .map(k => ({ key: k, text: legacyFormCustomElements.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
legacyFormCustomElements.enumMapping =
  legacyFormCustomElements.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
legacyFormCustomElements.mappingArray = Object.keys(
  legacyFormCustomElements.raw,
).map(k => k);

export const adminFormDataMappingElements = {};
adminFormDataMappingElements.raw = {
  SHORT_TEXT_DATA_MAPPING: 'Short text data mapping', // Text field
  NUMBER_DATA_MAPPING: 'Number data mapping', // Text number
  NUMBER_UOM_DATA_MAPPING: 'Number with UOM data mapping', // Textfield number
  NUMBER_DYNAMIC_UOM_DATA_MAPPING: 'Number with UOM option mapping', // Textfield number with UOM selector
  MULTIPLE_PHOTO_UPLOAD_DATA_MAPPING: 'Multiple photo upload data mapping', // Multiple photos upload
  VIDEO_UPLOAD_DATA_MAPPING: 'Video upload data mapping', // Video upload
  SELECT_DATA_MAPPING_ENUM: 'Single select data mapping', // Single select data mapping
  MULTIPLE_SELECT_DATA_MAPPING_ENUM: 'Multiple select data mapping', // Multiple select data mapping
  ANNUAL_CONSUMPTION_DATA_MAPPING_ENUM: 'Annual consumption data mapping enum', // Annual consumption data mapping
  FIXED_WATER_MANAGEMENT_SYSTEM_MAPPING: 'Water management system',
  FIXED_WATER_SOURCES_MAPPING: 'Water sources system',
  FIXED_MATERIAL_CUTOFF_MAPPING: 'Material cutoff',
  FIXED_HAS_WASTE_REDUCTION_PROGRAM_MAPPING: 'Waste reduction program',
  FIXED_IS_TRACKING_WASTE_STREAMS_MAPPING: 'Is tracking waste streams',
  FIXED_HAZARDOUS_WASTE_STREAM_VOLUME_MAPPING: 'Hazardous waste stream',
  FIXED_NON_HAZARDOUS_WASTE_STREAM_VOLUME_MAPPING: 'Non-hazardous waste stream',
  FIXED_WASTESTREAM_DISPOSAL_METHOD_MAPPING: 'Waste stream disposal method',
  FIXED_ENERGY_SOURCES_MAPPING: 'Energy sources system',
  FIXED_WASTE_WATER_TREATMENT_PROFFICIENCY_MAPPING:
    'Waste water management system',
  FIXED_WASTE_SOURCES_MAPPING: 'Waste volumes',
  FIXED_ENERGY_SOURCES_PEFCR_MAPPING: 'Energy consumption',
  FIXED_IS_OFFSETTING_CARBON_EMISSIONS_MAPPING: 'Carbon emissions',
  FIXED_IS_MONITORING_GHG_EMISSIONS_MAPPING: 'Ghg emissions',
};
adminFormDataMappingElements.mapping = { ...adminFormDataMappingElements.raw };
adminFormDataMappingElements.selectArrayOptions = Object.keys(
  adminFormDataMappingElements.raw,
)
  .map(k => ({ key: k, text: adminFormDataMappingElements.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
adminFormDataMappingElements.enumMapping =
  adminFormDataMappingElements.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
adminFormDataMappingElements.mappingArray = Object.keys(
  adminFormDataMappingElements.raw,
).map(k => k);

export const adminDataMappingTables = {};
adminDataMappingTables.raw = {
  COMPANY_TABLE: 'Company',
  COMPANY_ESG_TABLE: 'ESG', // Temp for esg
};
adminDataMappingTables.mapping = { ...adminDataMappingTables.raw };
adminDataMappingTables.selectArrayOptions = Object.keys(
  adminDataMappingTables.raw,
)
  .map(k => ({ key: k, text: adminDataMappingTables.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
adminDataMappingTables.enumMapping =
  adminDataMappingTables.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
adminDataMappingTables.mappingArray = Object.keys(
  adminDataMappingTables.raw,
).map(k => k);

export const adminDataMappingColumns = {};
adminDataMappingColumns.raw = {
  name: 'Display name',
  officialName: 'Official name',
  description: 'Description',
  county: 'County',
  city: 'City',
  zipCode: 'Zip code',
  addressLine1: 'Address line 1',
  addressLine2: 'Address line 2',
  phone: 'Phone',
  website: 'Website',
  founders: 'Founders',
  founded: 'Founded',
  companySize: 'Company size',
  companyType: 'Company type',
  facilityProcesses: 'Facility processes',
  annualProductionCapacity: 'Annual production capacity',
  minimumOrderQuantity: 'Minimum order quantity',
  minimumOrderQuantityPerStyle: 'Minimum order quantity per style',
  standardLeadTime: 'Standard lead time',
  numOfPermanentEmployees: 'Num of permanent employees',
  numOfMaleEmployees: 'Num of male employees',
  numOfFemaleEmployees: 'Num of female employees',
  shopId: 'Webshop id',
  imageList: 'Images',
  videoFileId: 'Video',
  higgId: 'HIGG ID',
  globalLocationNumber: 'GLN',
  vatId: 'VAT ID',
  dunsNumber: 'D-U-N-S Number',
  commercialRegisterNumber: 'Commercial Register Number',
  osHubId: 'OS Hub ID',
};
adminDataMappingColumns.mapping = { ...adminDataMappingColumns.raw };
adminDataMappingColumns.selectArrayOptions = Object.keys(
  adminDataMappingColumns.raw,
)
  .map(k => ({ key: k, text: adminDataMappingColumns.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
adminDataMappingColumns.enumMapping =
  adminDataMappingColumns.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const adminDataMappingColumnsNeedConfirmation = {};
adminDataMappingColumnsNeedConfirmation.raw = {
  name: 'Display name',
  officialName: 'Official name',
};
adminDataMappingColumnsNeedConfirmation.mapping = {
  ...adminDataMappingColumnsNeedConfirmation.raw,
};

export const companyCoreDataConfirmationText = {};
companyCoreDataConfirmationText.raw = {
  name: `Changing the display name of the company will be reflected immediately on that company's profile and will be visible from all companies on that company's network.`,
  officialName: `Changing the official name of the company will be reflected immediately on that company's profile and will be visible from all companies on that company's network. All relevant company searches will be affected.`,
};
companyCoreDataConfirmationText.mapping = {
  ...companyCoreDataConfirmationText.raw,
};

export const linkedAssets = {};
linkedAssets.raw = {
  CERTIFICATE: 'Certificate',
  SCOPE: 'Certificate:Scope',
  PRODUCT: 'Certificate:Product',
  TRANSACTION: 'Certificate:Transaction',
  COMPANY: 'Certificate:Company',
  COMPANY_DOCUMENT: 'Document',
  MEMBERSHIP: 'Certificate:Membership',
  FILE: 'Other',
  COMPANY_TABLE: 'Company',
  AUDIT: 'Audit',
};

linkedAssets.mapping = { ...linkedAssets.raw };

export const questionTypeTooltipInfo = {};
questionTypeTooltipInfo.raw = {
  SHORT_TEXT: 'Accepts any texts.',
  LONG_TEXT: 'Accepts any texts.',
  NUMBER: 'Accepts any number.',
  NUMBER_UOM: 'Accepts any number with UOM.',
  MULTIPLE_CHOICE: 'Accepts multiple answers.',
  CHECK_BOXES: 'Accepts only one answer.',
  SELECT: 'Accepts one choice.',
  ASSET_LINK: 'Accepts at least 1 document, certification or custom file.',
  FILE_UPLOAD: 'Accepts at least 1 file.',
  SHORT_TEXT_DATA_MAPPING:
    'Accepts any texts. Answer will be mapped into our system data.',
  NUMBER_DATA_MAPPING:
    'Accepts any number. Answer will be mapped into our system data.',
  NUMBER_UOM_DATA_MAPPING:
    'Accepts any number with uom. Answer will be mapped into our system data.',
  YES_NO_THEN:
    'Accepts yes and no question and then document, certification or custom file. Answer will be mapped into our system data.',
  MULTIPLE_PHOTO_UPLOAD_DATA_MAPPING:
    'Accepts atleast 1 image. Answer will be mapped into our system data.',
  VIDEO_UPLOAD_DATA_MAPPING:
    'Accepts 1 video. Answer will be mapped into our system data.',
  SELECT_DATA_MAPPING_ENUM:
    'Accepts 1 choice. Answer will be mapped into our system data.',
  MULTIPLE_SELECT_DATA_MAPPING_ENUM:
    'Accepts atleast 1 choice. Answer will be mapped into our system data.',
  ANNUAL_CONSUMPTION_DATA_MAPPING_ENUM:
    'Accepts atleast 1 answer. Answer will be mapped into our system data.',
  FIXED_ENERGY_SOURCES_MAPPING: 'Answer will be mapped into our system data.',
  FIXED_IS_OFFSETTING_CARBON_EMISSIONS_MAPPING:
    'Answer will be mapped into our system data.',
  FIXED_WATER_MANAGEMENT_SYSTEM_MAPPING:
    'Answer will be mapped into our system data.',
  FIXED_WATER_SOURCES_MAPPING: 'Answer will be mapped into our system data.',
  FIXED_WASTE_WATER_TREATMENT_PROFFICIENCY_MAPPING:
    'Answer will be mapped into our system data',
  FIXED_MATERIAL_CUTOFF_MAPPING: 'Answer will be mapped into our system data.',
  FIXED_HAS_WASTE_REDUCTION_PROGRAM_MAPPING:
    'Answer will be mapped into our system data.',
  FIXED_IS_TRACKING_WASTE_STREAMS_MAPPING:
    'Answer will be mapped into our system data.',
  FIXED_HAZARDOUS_WASTE_STREAM_VOLUME_MAPPING:
    'Answer will be mapped into our system data.',
  FIXED_NON_HAZARDOUS_WASTE_STREAM_VOLUME_MAPPING:
    'Answer will be mapped into our system data.',
  FIXED_WASTESTREAM_DISPOSAL_METHOD_MAPPING:
    'Answer will be mapped into our system data.',
  FIXED_WASTE_SOURCES_MAPPING: 'Answer will be mapped into our system data.',
  // c2c custom form elements
  NUMBER_DYNAMIC_CURRENCY:
    'Answer accepts any number with a currency selected.',
  SELECT_SINGLE_COWORKER: 'Answer accepts one employee in your company.',
  YEAR: 'Answer accepts a number in year format.',
  FIXED_ENERGY_SOURCES_PEFCR_MAPPING:
    'Answer will be mapped into our system data.',
};

questionTypeTooltipInfo.mapping = { ...questionTypeTooltipInfo.raw };

export const energySources = {};
energySources.raw = {
  COAL: 'Coal',
  PRIMARY_BIOMASS: 'Primary Biomass',
  SECONDARY_BIOMASS: 'Secondary Biomass',
  SOLAR_PHOTOVOLTAIC: 'Solar Photovoltaic',
  NATURAL_GAS: 'Natural gas',
  NUCLEAR: 'Nuclear',
  LIQUEFIED_PETROLEUM_GAS: 'Liquefied petroleum gas',
  DIESEL: 'Diesel',
  PETROL: 'Petrol',
  FUEL_OIL: 'Fuel oil',
  WIND: 'Wind',
  GEOTHERMAL: 'Geothermal',
  HYDRO: 'Hydro',
  CHILLED_WATER: 'Chilled water',
  TIDAL: 'Tidal',
  EXHAUST_HEAT: 'Exhaust Heat',
  UNKNOWN: 'Unknown',
  OTHER_RENEWABLE: 'Other Renewable',
};
energySources.mapping = { ...energySources.raw };
energySources.selectArrayOptions = Object.keys(energySources.raw)
  .map(k => ({ key: k, text: energySources.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const energySourcesPefcr = {};
energySourcesPefcr.raw = {
  COAL: 'Coal',
  PRIMARY_BIOMASS: 'Primary Biomass',
  SECONDARY_BIOMASS: 'Secondary Biomass',
  SOLAR_PHOTOVOLTAIC: 'Solar Photovoltaic',
  NATURAL_GAS: 'Natural gas',
  NUCLEAR: 'Nuclear',
  LIQUEFIED_PETROLEUM_GAS: 'Liquefied petroleum gas',
  DIESEL: 'Diesel',
  PETROL: 'Petrol',
  FUEL_OIL: 'Fuel oil',
  WIND: 'Wind',
  GEOTHERMAL: 'Geothermal',
  HYDRO: 'Hydro',
  CHILLED_WATER: 'Chilled water',
  TIDAL: 'Tidal',
  EXHAUST_HEAT: 'Exhaust Heat',
  UNKNOWN: 'Unknown',
};
energySourcesPefcr.mapping = { ...energySourcesPefcr.raw };
energySourcesPefcr.selectArrayOptions = Object.keys(energySourcesPefcr.raw)
  .map(k => ({ key: k, text: energySourcesPefcr.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const energySourcesPefcrUnits = [
  // Volume
  {
    label: 'm³',
    search: 'm³',
    value: 'CUBIC_METRE',
    quantity: 'volume',
    system: 'metric',
  },
  {
    label: 'l',
    search: 'Litre',
    value: 'LITRE',
    quantity: 'volume',
    system: 'metric',
  },
  {
    label: 'kWh',
    search: 'kWh',
    value: 'KILOWATT_HOUR',
    quantity: 'volume',
    system: 'metric',
  },
];
energySourcesPefcrUnits.selectArrayOptions = energySourcesPefcrUnits
  .map(u => ({ key: u.value, text: u.search, label: u.label }))
  .sort((a, b) => a.label.localeCompare(b.label));
energySourcesPefcrUnits.searchMapping = energySourcesPefcrUnits
  .sort((a, b) => a.search.localeCompare(b.search))
  .reduce((acc, obj) => ({ ...acc, [obj.value]: obj.search }), {});
export const consumptionCategories = {};
consumptionCategories.raw = {
  ELECTRICITY: 'Electricity',
  HEATING: 'Heating',
  COOLING: 'Cooling',
  STEAM: 'Steam',
};
consumptionCategories.mapping = { ...consumptionCategories.raw };
consumptionCategories.selectArrayOptions = Object.keys(
  consumptionCategories.raw,
)
  .map(k => ({ key: k, text: consumptionCategories.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const wastewaterTreatments = {};
wastewaterTreatments.raw = {
  OFFSITE_TREATMENT: 'Off-site water treatment',
  BOTH_ONSITE_OFFSITE_TREATMENT: 'Both onsite and offsite treatment',
  ZERO_LIQUID_DISCHARGE: 'Zero liquid discharge',
  NO_TREATMENT: 'No treatment',
  SEWER_SYSTEMS: 'Municipal/public sewer systems',
  ON_SITE_PARTIAL_RECLAMATION: 'On-site partial-reclamation',
  REUSE_OR_RECYCLING_WASTEWATER: "Reuse/recycling in company's own operations",
  ON_SITE_WATERSHED_MANAGEMENT: 'On-site watershed management',
  UNKNOWN: 'Unknown',
};
wastewaterTreatments.mapping = { ...wastewaterTreatments.raw };
wastewaterTreatments.selectArrayOptions = Object.keys(wastewaterTreatments.raw)
  .map(k => ({ key: k, text: wastewaterTreatments.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const wasteWaterTreatmentEfficiency = {};
wasteWaterTreatmentEfficiency.raw = {
  NO_WASTEWATER_TREATMENT: 'No treatment / low efficiency',
  AVERAGE_EFFICIENCY_WASTEWATER_TREATMENT: 'Average treatment efficiency',
  EFFICIENT_WASTEWATER_TREATMENT: 'High treatment efficiency',
};
wasteWaterTreatmentEfficiency.mapping = {
  ...wasteWaterTreatmentEfficiency.raw,
};
wasteWaterTreatmentEfficiency.selectArrayOptions = Object.keys(
  wasteWaterTreatmentEfficiency.raw,
)
  .map(k => ({ key: k, text: wasteWaterTreatmentEfficiency.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const waterSources = {};
waterSources.raw = {
  FRESH_SURFACE_WATER: 'Fresh surface water',
  RAINWATER: 'Rainwater',
  GROUNDWATER: 'Groundwater',
  PRODUCED_OR_PROCESSED_WATER: 'Produced or processed water',
  MUNICIPAL_WATER: 'Municipal water',
  WASTEWATER_FROM_ANOTHER_ORGANIZATION:
    'Water sources from another organization',
  UNKNOWN_ORIGIN: 'Unknown origin',
  SEAWATER: 'Seawater',
};
waterSources.mapping = { ...waterSources.raw };
waterSources.selectArrayOptions = Object.keys(waterSources.raw)
  .map(k => ({ key: k, text: waterSources.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const wastewaterSources = {};
wastewaterSources.raw = {
  HAZARDOUS_WASTEWATER: 'Hazardous wastewater',
  NON_HAZARDOUS_WASTEWATER: 'Non-hazardous wastewater',
  UNKNOWN: 'Unknown',
};
wastewaterSources.mapping = { ...wastewaterSources.raw };
wastewaterSources.selectArrayOptions = Object.keys(wastewaterSources.raw)
  .map(k => ({ key: k, text: wastewaterSources.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const treatmentOptions = {};
treatmentOptions.raw = {
  NO_TREATMENT: 'No treatment',
  SEWER_SYSTEMS: 'Municipal/public sewer systems',
  OFFSITE_TREATMENT: 'Off-site water treatment',
  ON_SITE_PARTIAL_RECLAMATION: 'On-site partial-reclamation',
  REUSE_OR_RECYCLING_WASTEWATER: "Reuse/recycling in company's own operations",
  ON_SITE_WATERSHED_MANAGEMENT: 'On-site watershed management',
  UNKNOWN: 'Unknown',
};
treatmentOptions.mapping = { ...treatmentOptions.raw };
treatmentOptions.selectArrayOptions = Object.keys(treatmentOptions.raw)
  .map(k => ({ key: k, text: treatmentOptions.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const treatmentEfficiency = {};
treatmentEfficiency.raw = {
  NO_WASTEWATER_TREATMENT: 'No treatment / low efficiency',
  AVERAGE_EFFICIENCY_WASTEWATER_TREATMENT: 'Average treatment efficiency',
  EFFICIENT_WASTEWATER_TREATMENT: 'High treatment efficiency',
};
treatmentEfficiency.mapping = { ...treatmentEfficiency.raw };
treatmentEfficiency.selectArrayOptions = Object.keys(treatmentEfficiency.raw)
  .map(k => ({ key: k, text: treatmentEfficiency.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const wasteCategories = {};
wasteCategories.raw = {
  METALS: 'Metals',
  GLASS: 'Glass',
  PAPER_AND_CARDBOARD: 'Paper & cardboard',
  PLASTICS: 'Plastics',
  WOOD_WASTE: 'Wood waste',
  RUBBER_WASTE: 'Rubber waste',
  ORGANIC_WASTE: 'Organic waste',
  DISCARDED_TEXTILES: 'Discarded textiles',
  WASTE_OILS: 'Waste oils',
  PAINTS_SOLVENTS: 'Paints & solvents',
  PCBS_AND_PCTS: 'PCBs & PCTs',
  UNKNOWN: 'Unknown',
};
wasteCategories.mapping = { ...wasteCategories.raw };
wasteCategories.selectArrayOptions = Object.keys(wasteCategories.raw)
  .map(k => ({ key: k, text: wasteCategories.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const disposalMethods = {};
disposalMethods.raw = {
  INCINERATE: 'Incinerate, burn, or dispose on-site (uncertified)',
  THIRD_PARTY_GARBAGE_COLLECTION:
    'Third-party garbage collection (uncertified)',
  MUNICIPAL_GARBAGE_COLLECTION: 'Municipal garbage collection',
  COMPOSTING_GARBAGE: 'Composting garbage',
  PRIVATE_THIRD_PARTY_DISPOSAL:
    'Private third-party responsible disposal (certified)',
  ON_SITE_DISPOSAL: 'On-site disposal (third-party reviewed or audited)',
  WASTE_SEPARATED_AND_RECYCLED:
    "Waste is separated and recycled or reused for company's own production or donated/provided to other facilities",
  UNKNOWN: 'Unknown',
};
disposalMethods.mapping = { ...disposalMethods.raw };
disposalMethods.selectArrayOptions = Object.keys(disposalMethods.raw)
  .map(k => ({ key: k, text: disposalMethods.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
export const wasteUnits = [
  {
    label: 'kg',
    search: 'kg',
    value: 'KILOGRAM',
    quantity: 'weight',
    system: 'metric',
  },
  {
    label: 't',
    search: 'metric ton',
    value: 'METRIC_TON',
    quantity: 'weight',
    system: 'metric',
  },
];
wasteUnits.selectArrayOptions = wasteUnits
  .map(u => ({ key: u.value, text: u.search, label: u.label }))
  .sort((a, b) => a.label.localeCompare(b.label));
wasteUnits.searchMapping = wasteUnits
  .sort((a, b) => a.search.localeCompare(b.search))
  .reduce((acc, obj) => ({ ...acc, [obj.value]: obj.search }), {});

export const esgQuestions = {};
esgQuestions.raw = {
  IS_USING_ENERGY_MANAGEMENT_SYSTEM: 'IS_USING_ENERGY_MANAGEMENT_SYSTEM',
  ENERGY_MANAGEMENT_SYSTEM: 'ENERGY_MANAGEMENT_SYSTEM',
  ENERGY_SOURCES: 'ENERGY_SOURCES',
  ENERGY_SOURCES_PEFCR: 'ENERGY_SOURCES_PEFCR',
  IS_MONITORING_GHG_EMISSIONS: 'IS_MONITORING_GHG_EMISSIONS',
  CARBON_INTENSITY_SCOPE_1_2: 'CARBON_INTENSITY_SCOPE_1_2',
  CARBON_INTENSITY_SCOPE_1: 'CARBON_INTENSITY_SCOPE_1',
  CARBON_INTENSITY_SCOPE_2: 'CARBON_INTENSITY_SCOPE_2',
  CARBON_INTENSITY_SCOPE_3: 'CARBON_INTENSITY_SCOPE_3',
  IS_OFFSETTING_CARBON_EMISSIONS: 'IS_OFFSETTING_CARBON_EMISSIONS',
  GHG_EMISSIONS_OFFSET_SCOPE_1: 'GHG_EMISSIONS_OFFSET_SCOPE_1',
  GHG_EMISSIONS_OFFSET_SCOPE_2: 'GHG_EMISSIONS_OFFSET_SCOPE_2',
  GHG_EMISSIONS_OFFSET_SCOPE_3: 'GHG_EMISSIONS_OFFSET_SCOPE_3',
  IS_USING_WATER_MANAGEMENT_SYSTEM: 'IS_USING_WATER_MANAGEMENT_SYSTEM',
  WATER_MANAGEMENT_SYSTEM: 'WATER_MANAGEMENT_SYSTEM',
  WATER_SOURCES: 'WATER_SOURCES',
  WASTEWATER_SOURCES: 'WASTEWATER_SOURCES',
  WASTE_SOURCES: 'WASTE_SOURCES',
  IS_TRACKING_WASTEWATER: 'IS_TRACKING_WASTEWATER',
  WASTEWATER_TREATMENT: 'WASTEWATER_TREATMENT',
  WASTE_WATER_TREATMENT_PROFFICIENCY: 'WASTE_WATER_TREATMENT_PROFFICIENCY',
  MATERIAL_CUTOFF: 'MATERIAL_CUTOFF',
  HAS_WASTE_REDUCTION_PROGRAM: 'HAS_WASTE_REDUCTION_PROGRAM',
  IS_TRACKING_WASTE_STREAMS: 'IS_TRACKING_WASTE_STREAMS',
  HAZARDOUS_WASTE_STREAM_VOLUME: 'HAZARDOUS_WASTE_STREAM_VOLUME',
  NON_HAZARDOUS_WASTE_STREAM_VOLUME: 'NON_HAZARDOUS_WASTE_STREAM_VOLUME',
  WASTESTREAM_DISPOSAL_METHOD: 'WASTESTREAM_DISPOSAL_METHOD',
};
esgQuestions.mapping = { ...esgQuestions.raw };

export const productEcoQuestions = {};
productEcoQuestions.raw = {
  ENERGY_SOURCES: 'ENERGY_SOURCES',
  WATER_SOURCES: 'WATER_SOURCES',
  MATERIAL_CUTOFF: 'MATERIAL_CUTOFF',
  SHIPMENT_METHOD: 'SHIPMENT_METHOD',
  ANNUAL_PRODUCTION_CAPACITY: 'ANNUAL_PRODUCTION_CAPACITY',
};
productEcoQuestions.mapping = { ...productEcoQuestions.raw };

export const wasteCategory = {};

wasteCategory.raw = [
  {
    name: 'Metals',
    value: 'METALS',
    type: 'Non-Hazardous ',
  },
  {
    name: 'Glass',
    value: 'GLASS',
    type: 'Non-Hazardous ',
  },
  {
    name: 'Paper & cardboard',
    value: 'PAPER_AND_CARDBOARD',
    type: 'Non-Hazardous ',
  },
  {
    name: 'Plastics',
    value: 'PLASTICS',
    type: 'Non-Hazardous ',
  },
  {
    name: 'Wood waste',
    value: 'WOOD_WASTE',
    type: 'Non-Hazardous ',
  },
  {
    name: 'Rubber waste',
    value: 'RUBBER_WASTE',
    type: 'Non-Hazardous ',
  },
  {
    name: 'Discarded textiles',
    value: 'DISCARDED_TEXTILES',
    type: 'Non-Hazardous ',
  },
  {
    name: 'Organic Waste',
    value: 'ORGANIC_WASTE',
    type: 'Non-Hazardous ',
  },
  {
    name: 'Waste Oils',
    value: 'WASTE_OILS',
    type: 'Hazardous ',
  },
  {
    name: 'Paints & solvents',
    value: 'PAINTS_AND_SOLVENTS',
    type: 'Hazardous ',
  },
  {
    name: 'PCBs & PCTs',
    value: 'PCBs_AND_PCTs',
    type: 'Hazardous ',
  },
];

wasteCategory.mapping = wasteCategory.raw
  .sort((a, b) => a.name.localeCompare(b.name))
  .reduce((acc, obj) => ({ ...acc, [obj.value]: obj.name }), {});
wasteCategory.selectArrayOptions = Object.keys(wasteCategory.mapping).map(
  k => ({
    key: k,
    text: wasteCategory.mapping[k],
  }),
);

export const productTabs = {};
productTabs.raw = {
  OVERVIEW: 'OVERVIEW',
  SUPPLY_CHAIN: 'SUPPLY_CHAIN',
  ECO_FOOTPRINT: 'ECO_FOOTPRINT',
  BADGES: 'BADGES',
  WEBSHOP_PREVIEW: 'WEBSHOP_PREVIEW',
  QRCODE: 'QRCODE',
  BILL_OF_MATERIALS: 'BILL_OF_MATERIALS',
  CERTIFICATIONS: 'CERTIFICATIONS',
};
productTabs.mapping = { ...productTabs.raw };

export const companyTabs = {};
companyTabs.raw = {
  GLOBAL_INFORMATION: 'GLOBAL_INFORMATION',
  CUSTOM_INFORMATION: 'CUSTOM_INFORMATION',
  ENVIRONMENTAL_DATA: 'ENVIRONMENTAL_DATA',
  CERTIFICATIONS: 'CERTIFICATIONS',
  USERS: 'USERS',
  DOCUMENTS: 'DOCUMENTS',
  AUDITS: 'AUDITS',
  RISK_PROFILE: 'RISK_PROFILE',
  RELATIONSHIPS: 'RELATIONSHIPS',
  PRODUCTS: 'PRODUCTS',
};
companyTabs.mapping = { ...companyTabs.raw };

export const certificateTabs = {};
certificateTabs.raw = {
  INREVIEW_CERTIFICATES: 'REQUESTED',
  ARCHIVED_CERTIFICATES: 'ARCHIVED',
  REMOVED_CERTIFICATES: 'REMOVED',
};
certificateTabs.mapping = { ...certificateTabs.raw };

export const connectionType = {};
connectionType.enum =
  dataPoints.getDataPointById('connection_type')?.dataPointDefinition
    ?.options ?? [];
connectionType.raw = connectionType.enum?.length
  ? Object.fromEntries(connectionType.enum.map(item => [item.key, item.text]))
  : { SUPPLIER: 'Supplier', CLIENT: 'Client' };
connectionType.mapping = { ...connectionType.raw };
connectionType.enumMapping = Object.keys(connectionType.raw)
  .map(k => ({ key: k, text: connectionType.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});
connectionType.selectArrayOptions = Object.keys(connectionType.raw).map(k => ({
  key: k,
  text: connectionType.raw[k],
}));

export const cascadeMappingConnectionType = { ...connectionType };
cascadeMappingConnectionType.raw = {
  ...connectionType.raw,
  NOT_CONNECTED: 'Not Connected',
};
cascadeMappingConnectionType.mapping = { ...cascadeMappingConnectionType.raw };
cascadeMappingConnectionType.enumMapping = Object.keys(
  cascadeMappingConnectionType.raw,
)
  .map(connectionTypeKey => ({
    key: connectionTypeKey,
    text: cascadeMappingConnectionType.raw[connectionTypeKey],
  }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});
cascadeMappingConnectionType.selectArrayOptions = Object.keys(
  cascadeMappingConnectionType.raw,
).map(connectionTypeKey => ({
  key: connectionTypeKey,
  text: cascadeMappingConnectionType.raw[connectionTypeKey],
}));

export const entityScreeningConnectionType = { ...connectionType };
entityScreeningConnectionType.raw = {
  ...connectionType.raw,
  NOT_CONNECTED: 'Not Connected',
};
entityScreeningConnectionType.mapping = {
  ...entityScreeningConnectionType.raw,
};
entityScreeningConnectionType.enumMapping = Object.keys(
  entityScreeningConnectionType.raw,
)
  .map(connectionTypeKey => ({
    key: connectionTypeKey,
    text: entityScreeningConnectionType.raw[connectionTypeKey],
  }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});
entityScreeningConnectionType.selectArrayOptions = Object.keys(
  entityScreeningConnectionType.raw,
).map(connectionTypeKey => ({
  key: connectionTypeKey,
  text: entityScreeningConnectionType.raw[connectionTypeKey],
}));

export const entityScreeningValidationOptions = {
  FLAGGED: 'FLAGGED',
  DISMISSED: 'DISMISSED',
  REVALIDATE: 'REVALIDATE',
};

export const questionnaireResponseAnswerStatus = {};
// Sourced from @retracedgmbh/modules — the same four values the backend
// validates with `z.enum(QUESTION_RESPONSE_STATUSES)`. Built from the contract
// tuple so a value added there cannot be missed here.
questionnaireResponseAnswerStatus.raw = Object.fromEntries(
  QUESTION_RESPONSE_STATUSES.map(status => [status, status]),
);

questionnaireResponseAnswerStatus.enumMapping = {
  ...questionnaireResponseAnswerStatus.raw,
};
questionnaireResponseAnswerStatus.mapping = Object.keys(
  questionnaireResponseAnswerStatus.raw,
).reduce((acc, obj) => ({ ...acc, [obj]: obj }), {});
questionnaireResponseAnswerStatus.selectArrayOptions = Object.keys(
  questionnaireResponseAnswerStatus.raw,
).map(k => ({
  key: k,
  text: questionnaireResponseAnswerStatus.raw[k],
}));

export const materialCategories = {};
materialCategories.raw = {
  NATURAL_FIBER: 'Natural Fiber',
  SYNTHETIC_FIBER: 'Synthetic Fiber',
  LEATHER: 'Leather',
  NATURAL_MATERIAL: 'Natural Material',
  SYNTHETIC_MATERIAL: 'Synthetic Material',
  METAL: 'Metal',
};
materialCategories.mapping = { ...materialCategories.raw };
materialCategories.selectArrayOptions = Object.keys(materialCategories.raw)
  .map(k => ({ key: k, text: materialCategories.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const riskIndexSourceTypes = {};
riskIndexSourceTypes.raw = { MAIN: 'Main', ADDITIONAL: 'Additional' };
riskIndexSourceTypes.mapping = { ...riskIndexSourceTypes.raw };
riskIndexSourceTypes.selectArrayOptions = Object.keys(
  riskIndexSourceTypes.raw,
).map(k => ({
  key: k,
  text: riskIndexSourceTypes.raw[k],
}));

export const riskGrossSourceTypes = {
  MAIN: 'main',
  ADDITIONAL: 'additional',
  Main: 'Main',
};

export const riskLevels = {};
riskLevels.raw = {
  LOW: 'Low',
  MODERATE: 'Moderate',
  MEDIUM: 'Medium',
  HIGH: 'High',
  EXTREME: 'Extreme',
};
riskLevels.mapping = { ...riskLevels.raw };
riskLevels.selectArrayOptions = Object.keys(riskLevels.raw).map(riskLevel => ({
  key: riskLevels.raw[riskLevel],
  text: riskLevels.raw[riskLevel],
}));

export const transactionStatus = {};
transactionStatus.raw = {
  DISPATCHED: 'Dispatched',
  DESPATCHED: 'Despatched',
  RECEIVED: 'Received',
  PENDING: 'Received',
  REJECTED: 'Mismatch',
  ACCEPTED: 'Received',
};
transactionStatus.mapping = { ...transactionStatus.raw };
transactionStatus.enumMapping = Object.keys(transactionStatus.raw)
  .map(k => ({ key: k, text: transactionStatus.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});
transactionStatus.selectArrayOptions = Object.keys(transactionStatus.raw)
  .map(k => ({ key: k, text: transactionStatus.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const statusTags = {};
statusTags.raw = {
  DISPATCHED: 'Dispatched',
  DESPATCHED: 'Despatched',
  RECEIVED: 'Received',
  PENDING: 'Received',
  REJECTED: 'Mismatch',
  ACCEPTED: 'Received',
  STARTED: 'Started',
  FINISHED: 'Finished',
};
statusTags.mapping = { ...statusTags.raw };
statusTags.enumMapping = Object.keys(statusTags.raw)
  .map(k => ({ key: k, text: statusTags.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

export const productionProcesses = {};
productionProcesses.raw = {
  RAW_MATERIAL_CREATION: 'Raw Material Creation',
  MATERIAL_RECYCLING: 'Material Recycling',
  RAW_MATERIAL_PROCESSING: 'Raw Material Processing',
  YARN_PROCESSING: 'Yarn Processing',
  FABRIC_PROCESSING: 'Fabric Processing',
  LEATHER_TANNING: 'Leather Tanning',
  TRIMS_AND_COMPONENTS: 'Trims and Componennts',
  PACKAGING: 'Packing',
  MANUFACTURING: 'Manufacturing',
  SOURCING_AND_IMPORT: 'Sourcing and Import',
  WAREHOUSE: 'Warehouse',
  RETAILER: 'Retailer',
  COMPLIANCE: 'Compliance',
};

productionProcesses.enumMapping = Object.keys(productionProcesses.raw)
  .map(k => ({ key: k, text: productionProcesses.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});
productionProcesses.mapping = { ...productionProcesses.raw };
productionProcesses.selectArrayOptions = Object.keys(productionProcesses.raw)
  .map(k => ({ key: k, text: productionProcesses.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const riskAnalysisTableTypes = {};
riskAnalysisTableTypes.raw = {
  NET: 'Net',
  GROSS: 'Gross',
};
riskAnalysisTableTypes.enumMapping = Object.keys(riskAnalysisTableTypes.raw)
  .map(k => ({ key: k, text: riskAnalysisTableTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

riskAnalysisTableTypes.mapping = { ...riskAnalysisTableTypes.raw };
riskAnalysisTableTypes.selectArrayOptions = Object.keys(
  riskAnalysisTableTypes.mapping,
)
  .map(k => ({ key: k, text: `${riskAnalysisTableTypes.mapping[k]} Risks` }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const riskAnalysisMitigationTypes = {};
riskAnalysisMitigationTypes.raw = {
  AUDITS: 'Audits',
  STANDARDS: 'Standards',
};
riskAnalysisMitigationTypes.selectArrayOptions = Object.keys(
  riskAnalysisMitigationTypes.raw,
)
  .map(k => ({ key: k, text: riskAnalysisMitigationTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const riskAnalysisProofTypes = {};
riskAnalysisProofTypes.raw = {
  DOCUMENT: 'Documents',
  AUDIT: 'Audits',
  CERTIFICATION: 'Certifications',
};

riskAnalysisProofTypes.enumMapping = Object.keys(riskAnalysisProofTypes.raw)
  .map(k => ({ key: k, text: riskAnalysisProofTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

riskAnalysisProofTypes.mapping = { ...riskAnalysisProofTypes.raw };
riskAnalysisProofTypes.selectArrayOptions = Object.keys(
  riskAnalysisProofTypes.mapping,
)
  .map(k => ({ key: k, text: riskAnalysisProofTypes.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const TRACING_TRANSACTION_TYPES_ENUM = {
  CUSTOM_CLEARANCE: 'CUSTOM_CLEARANCE',
  LAB_TEST: 'LAB_TEST',
  TRACING_ORIGIN_ORDERS: 'TRACING_ORIGIN_ORDERS',
  TRACING_PURCHASE_ORDERS: 'TRACING_PURCHASE_ORDERS',
  TRACING_SALES_ORDERS: 'TRACING_SALES_ORDERS',
  SUPPLY_CHAINS: 'SUPPLY_CHAINS',
  SUPPLY_CHAIN_MAPPINGS: 'SUPPLY_CHAIN_MAPPINGS',
  CASCADE_MAPPINGS: 'CASCADE_MAPPINGS',
};

export const tracingTransactionTypes = {};
tracingTransactionTypes.raw = {
  CUSTOM_CLEARANCE: 'Customs clearance',
  LAB_TEST: 'Lab test',
};
tracingTransactionTypes.enumMapping = Object.keys(tracingTransactionTypes.raw)
  .map(k => ({ key: k, text: tracingTransactionTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

tracingTransactionTypes.mapping = { ...tracingTransactionTypes.raw };
tracingTransactionTypes.selectArrayOptions = Object.keys(
  tracingTransactionTypes.mapping,
)
  .map(k => ({ key: k, text: `${tracingTransactionTypes.mapping[k]}` }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const tracingAttachmentTemplateTypes = {};
export const tracingAttachmentNodeTypes = {};
export const tracingAttachmentLinkTypes = {};
export const tracingAttachmentOrderTypes = {};
export const tracingAttachmentOriginTypes = {};
export const tracingAttachmentTypes = {};

tracingAttachmentTemplateTypes.raw = {
  INVOICE: 'Invoice',
  CONTRACT: 'Contract',
  PRODUCTION_RECORDS: 'Production records',
  WAREHOUSING_RECORDS: 'Warehousing records',
  PAYMENT_VOUCHER: 'Payment voucher',
  DELIVERY_NOTE: 'Delivery note',
  PRODUCT_SPECIFICATION: 'Product specification',
  CERTIFICATE_OF_ORIGIN: 'Certificate of origin',
  CUSTOMS_CLEARANCE: 'Customs clearance',
  BILL_OF_LADING: 'Bill of lading',
  PACKING_LIST: 'Packing list',
  COMMERCIAL_INVOICE: 'Commercial invoice',
  TRANSPORTATION_INVOICE: 'Transportation invoice',
  TRANSACTION_CERTIFICATE: 'Transaction certificate',
  PURCHASE_ORDER: 'Purchase order',
  AFFIDAVITS: 'Affidavits',
  PRODUCTION_MASS_BALANCE_AND_LOSS_RATE:
    'Production mass balance and loss rate',
  CCUS_TRACER_TESTING_CERTIFICATE:
    'Declarations and certifications related to CCU materials',
  INSPECTION_REPORT: 'Inspection Report',
  TEST_REPORT: 'Test Report',
};

tracingAttachmentNodeTypes.raw = {
  BUSINESS_LICENSE: 'Business license',
  EMPLOYMENT_CONTRACT_AGREEMENT: 'Employee contract/agreement',
  AUDIT_REPORT: 'Audit report',
};
tracingAttachmentLinkTypes.raw = {
  INVOICE_RECEIPT: 'Invoice / receipt',
  PURCHASE_ORDER: 'Purchase order',
  SALES_CONTRACT: 'Sales contract',
  PRODUCTION_RECORDS: 'Production records',
  BILL_OF_LADING: 'Bill of lading',
  CUSTOMS_CLEARANCE: 'Customs clearance',
  PACKING_LIST: 'Packing list',
  MATERIAL_CERTIFICATE: 'Material certificate',
  TEXTILE_DECLARATION: 'Textile declaration',
  MATERIAL_AFFIDAVIT: 'Material affidavit',
  PROOF_OF_PAYMENT: 'Proof of payment',
  SUPPLEMENTARY_TEXTILE_DECLARATION: 'Supplementary declaration',
  CERTIFICATE_OF_ORIGIN: 'Certificate of origin',
};
tracingAttachmentOrderTypes.raw = {
  PURCHASE_ORDER: 'Purchase order',
  SALES_CONTRACT: 'Sales contract',
  INVOICE_RECEIPT: 'Invoice / receipt',
};

tracingAttachmentOriginTypes.raw = {
  CERTIFICATE_OF_ORIGIN: 'Certificate of origin',
};

tracingAttachmentTypes.mapping = {
  ...tracingAttachmentNodeTypes.raw,
  ...tracingAttachmentLinkTypes.raw,
  ...tracingAttachmentOriginTypes.raw,
  ...tracingAttachmentTemplateTypes.raw,
};

tracingAttachmentTypes.enumMapping = Object.keys(tracingAttachmentTypes.mapping)
  .map(k => ({ key: k, text: tracingAttachmentTypes.mapping[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

tracingAttachmentNodeTypes.selectArrayOptions = Object.keys(
  tracingAttachmentNodeTypes.raw,
)
  .map(k => ({ key: k, text: `${tracingAttachmentNodeTypes.raw[k]}` }))
  .sort((a, b) => a.text.localeCompare(b.text));
tracingAttachmentNodeTypes.enumMapping = Object.keys(
  tracingAttachmentNodeTypes.raw,
)
  .map(k => ({ key: k, text: tracingAttachmentNodeTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

tracingAttachmentLinkTypes.selectArrayOptions = Object.keys(
  tracingAttachmentLinkTypes.raw,
)
  .map(k => ({ key: k, text: `${tracingAttachmentLinkTypes.raw[k]}` }))
  .sort((a, b) => a.text.localeCompare(b.text));
tracingAttachmentLinkTypes.enumMapping = Object.keys(
  tracingAttachmentLinkTypes.raw,
)
  .map(k => ({ key: k, text: tracingAttachmentLinkTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

tracingAttachmentOrderTypes.enumMapping = Object.keys(
  tracingAttachmentOrderTypes.raw,
)
  .map(k => ({ key: k, text: tracingAttachmentOrderTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

tracingAttachmentOriginTypes.enumMapping = Object.keys(
  tracingAttachmentOriginTypes.raw,
)
  .map(k => ({ key: k, text: tracingAttachmentOriginTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

tracingAttachmentTemplateTypes.selectArrayOptions = Object.keys(
  tracingAttachmentTemplateTypes.raw,
)
  .map(k => ({ key: k, text: `${tracingAttachmentTemplateTypes.raw[k]}` }))
  .sort((a, b) => a.text.localeCompare(b.text));
tracingAttachmentTemplateTypes.enumMapping = Object.keys(
  tracingAttachmentTemplateTypes.raw,
)
  .map(k => ({ key: k, text: tracingAttachmentTemplateTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

export const tracingAttachmentDocumentTypes = {};
export const tracingAttachmentDocumentImages = {};
export const tracingAttachmentDocumentDescription = {};

tracingAttachmentDocumentTypes.raw = {
  INVOICE: 'Invoice',
  CONTRACT: 'Contract',
  PRODUCTION_RECORDS: 'Production records',
  WAREHOUSING_RECORDS: 'Warehousing records',
  PAYMENT_VOUCHER: 'Payment voucher',
  DELIVERY_NOTE: 'Delivery note',
  PRODUCT_SPECIFICATION: 'Product specification',
  CERTIFICATE_OF_ORIGIN: 'Certificate of origin',
  CUSTOMS_CLEARANCE: 'Customs clearance',
  BILL_OF_LADING: 'Bill of lading',
  PACKING_LIST: 'Packing list',
  COMMERCIAL_INVOICE: 'Commercial invoice',
  TRANSPORTATION_INVOICE: 'Transportation invoice',
  TRANSACTION_CERTIFICATE: 'Transaction certificate',
  PURCHASE_ORDER: 'Purchase order',
  AFFIDAVITS: 'Affidavits',
  PRODUCTION_MASS_BALANCE_AND_LOSS_RATE:
    'Production mass balance and loss rate',
  CCUS_TRACER_TESTING_CERTIFICATE:
    'Declarations and certifications related to CCU materials',
  INSPECTION_REPORT: 'Inspection Report',
  TEST_REPORT: 'Test Report',
};

tracingAttachmentDocumentTypes.selectArrayOptions = Object.keys(
  tracingAttachmentDocumentTypes.raw,
)
  .map(k => ({ key: k, text: `${tracingAttachmentDocumentTypes.raw[k]}` }))
  .sort((a, b) => a.text.localeCompare(b.text));

tracingAttachmentDocumentImages.raw = {
  INVOICE: 'invoice_example.webp',
  CONTRACT: 'contract_example.jpg',
  PRODUCTION_RECORDS: 'production_records_example.png',
  WAREHOUSING_RECORDS: 'warehousing_records_example.jpg',
  PAYMENT_VOUCHER: 'payment_voucher_example.png',
  DELIVERY_NOTE: 'delivery_note_example.png',
  PRODUCT_SPECIFICATION: 'product_specification.png',
  CERTIFICATE_OF_ORIGIN: 'certificate_of_origin_example.jpg',
  CUSTOMS_CLEARANCE: 'customs_clearance_example.jpg',
  BILL_OF_LADING: 'bill_of_landing_example.jpeg',
  PACKING_LIST: 'packing_list_example.png',
  COMMERCIAL_INVOICE: 'commercial_invoice.webp',
  TRANSPORTATION_INVOICE: 'transportation_invoice_example.png',
  TRANSACTION_CERTIFICATE: 'transaction_certificate_example.jpg',
  PURCHASE_ORDER: 'purchase_order_example.jpeg',
  AFFIDAVITS: 'affidavit_example.png',
  INSPECTION_REPORT: 'inspection_report_example.png',
  TEST_REPORT: 'test_report_example.png',
};

tracingAttachmentDocumentDescription.raw = {
  INVOICE: 'Invoice for received orders',
  CONTRACT: 'Contract for received order',
  PRODUCTION_RECORDS:
    'Production records for produced order - Including batch numbers, order numbers, production dates and quantities, etc.',
  WAREHOUSING_RECORDS:
    'Warehousing records for received order - Documents, as part of of inventory management,  focused on knowing which products are incoming and outgoing, as well as where each item is located.',
  PAYMENT_VOUCHER: 'Payment voucher for received order - Proof of payment',
  DELIVERY_NOTE:
    'Delivery note for produced order - Documents accompanying the shipment of goods that list de description and quantity of goods delivered.',
  PRODUCT_SPECIFICATION:
    'Product specification for produced order- File or files containing a detailed description of a product.',
  CERTIFICATE_OF_ORIGIN:
    'Certificate of origin for produced order - Official document that states in which country or group of countries a certain product was manufactured.',
  CUSTOMS_CLEARANCE:
    'Customs clearance for received order - Proof that the shipment has customs clearance to enter the country',
  BILL_OF_LADING: 'Bill of lading for produced order - Transportation records',
  PACKING_LIST:
    'Packing list for produced order - Including product/style numbers, bale IDs where applicable, etc.',
  COMMERCIAL_INVOICE: 'Commercial invoice for received order',
  TRANSPORTATION_INVOICE: 'Transportation invoice for produced order',
  TRANSACTION_CERTIFICATE:
    'Transaction certificate for produced order - Document that verifies the goods being shipped (or delivered) from one organization to the next conform to a given standard.',
  PURCHASE_ORDER: 'Purchase order for received order',
  AFFIDAVITS:
    "Affidavit - Legal document in which you're claiming that the information within the document is true and correct to the best of your knowledge",
  INSPECTION_REPORT:
    'Inspection report for produced order - Document that records the results of a quality or compliance inspection carried out on goods or materials.',
  TEST_REPORT:
    'Test report for produced order - Document that presents the results of laboratory or quality tests performed on goods or materials to verify they meet required standards.',
};

tracingAttachmentDocumentTypes.mapping = tracingAttachmentDocumentTypes.raw;
tracingAttachmentDocumentImages.mapping = tracingAttachmentDocumentImages.raw;
tracingAttachmentDocumentDescription.mapping =
  tracingAttachmentDocumentDescription.raw;

tracingAttachmentDocumentTypes.enumMapping = Object.keys(
  tracingAttachmentDocumentTypes.mapping,
)
  .map(k => ({ key: k, text: tracingAttachmentDocumentTypes.mapping[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

export const tracingOrderStatus = {};
tracingOrderStatus.raw = {
  IN_PROGRESS: 'In progress',
  IN_REVIEW: 'In review',
  COMPLETED: 'Completed',
};
tracingOrderStatus.textColors = {
  IN_PROGRESS: 'primary',
  IN_REVIEW: 'warning',
  COMPLETED: 'success',
};

tracingOrderStatus.mapping = { ...tracingOrderStatus.raw };
tracingOrderStatus.selectArrayOptions = Object.keys(
  tracingOrderStatus.mapping,
).map(k => ({
  key: k,
  text: tracingOrderStatus.mapping[k],
}));
tracingOrderStatus.unsetFilterOption = { key: 'N/A', text: 'N/A' };
tracingOrderStatus.filterOptions = [
  ...tracingOrderStatus.selectArrayOptions,
  tracingOrderStatus.unsetFilterOption,
];

export const MODAL_ASSET_TYPE_ENUMS = {
  ADD_ORDER: 'ADD_ORDER',
  ADD_ORIGIN: 'ADD_ORIGIN',
  NODE: 'NODE',
  LINK: 'LINK',
  LINK_PRODUCT: 'LINK_PRODUCT',
  CREATE_PRODUCT: 'CREATE_PRODUCT',
  START_PRODUCT_TRANSFORMATION: 'START_PRODUCT_TRANSFORMATION',
  ADD_PURCHASE_ORDER: 'ADD_PURCHASE_ORDER',
  ADD_SALES_ORDER: 'ADD_SALES_ORDER',
  CREATE_INTERNAL_ORDER: 'CREATE_INTERNAL_ORDER',
  CREATE_COMPANY: 'CREATE_COMPANY',
  CREATE_USER: 'CREATE_USER',
  CREATE_NETWORK_PRODUCT: 'CREATE_NETWORK_PRODUCT',
  CREATE_STYLE: 'CREATE_STYLE',
  LINK_PRODUCTION_DETAILS: 'LINK_PRODUCTION_DETAILS',
  NODE_PRODUCTION_DETAILS: 'NODE_PRODUCTION_DETAILS',
  PRODUCT_DETAILS: 'PRODUCT_DETAILS',
  ATTACHMENT_BULK_UPLOAD: 'ATTACHMENT_BULK_UPLOAD',
  CREATE_TRANSACTION: 'CREATE_TRANSACTION',
  CREATE_LOT: 'CREATE_LOT',
  CREATE_PRODUCTION_PROCESS: 'CREATE_PRODUCTION_PROCESS',
  CREATE_PRODUCTION: 'CREATE_PRODUCTION',
  EXTEND_SUPPLY_CHAIN: 'EXTEND_SUPPLY_CHAIN',
  EDIT_SUPPLY_CHAIN_LINK: 'EDIT_SUPPLY_CHAIN_LINK',
  EDIT_NODE_FACILITY_PROCESS: 'EDIT_NODE_FACILITY_PROCESS',
  PASTE_SUPPLY_CHAIN: 'PASTE_SUPPLY_CHAIN',
  DELETE_NODE: 'DELETE_NODE',
  REPLACE_COMPANY: 'REPLACE_COMPANY',
  PASTE_PRODUCT_MAP_MODAL: 'PASTE_PRODUCT_MAP',
};

export const CASCADE_TRACING_ASSET_TYPES = {
  COMPANIES: 'COMPANIES',
};

export const USER_PREFERENCE_KEY_ENUMS = {
  // Notification settings
  NOTIF_EMAIL: 'notifEmail',
  NOTIF_ADMIN_EMAIL: 'notifAdminEmail',

  // Filter preferences
  FILTER_COMPANIES_LIST: 'filterCompaniesList',
  FILTER_PRODUCTS_LIST: 'filterProductsList',

  // Table onboard columns
  ONBOARD_COLUMN_COMPANIES_LIST: 'onboardColumnCompaniesList',
  ONBOARD_COLUMN_PRODUCTS_LIST: 'onboardColumnProductsList',

  SAVED_TABLE_PREFERENCES: 'savedTablePreferences',
  //language preferences
  USERS_LANGUAGE: 'userLanguage',

  ANALYTICS_FILTER_PREFERENCES: 'savedAnalyticsFilterPreferences',
};

export const TRACE_TYPE_ENUM = {
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  SALES_ORDER: 'SALES_ORDER',
};

export const SUPPLY_CHAIN_TRANSPARENCY_ID = 'AMVWLSWVAPIP4A4UV8';

export const PRODUCTS_QUERY_KEYS_ENUM = {
  supplierCompanyIds: 'supplierCompanyIds',
  productLevelId: 'productLevelId',
};

export const PRODUCTS_QUERY_KEYS = Object.values(PRODUCTS_QUERY_KEYS_ENUM);

export const CERTIFICATES_FETCH_TYPES_NUM = {
  ALL_CERTIFICATES: 'ALL_CERTIFICATES',
  PRODUCT: 'PRODUCT',
  CERTFICATE: 'CERTFICATE',
};

export const productCategoryStandardFields = {};
productCategoryStandardFields.raw = {
  FABRIC_WEIGHT: 'Fabric weight',
  FABRIC_WIDTH: 'Fabric width',
};
productCategoryStandardFields.mapping = {
  ...productCategoryStandardFields.raw,
};
productCategoryStandardFields.selectArrayOptions = Object.keys(
  productCategoryStandardFields.mapping,
)
  .map(k => ({ key: k, text: productCategoryStandardFields.mapping[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const QUESTION_TYPES_ENUM = {
  SHORT_TEXT: 'SHORT_TEXT', // Text field
  LONG_TEXT: 'LONG_TEXT', // Textarea
  NUMBER: 'NUMBER', // Textfield number
  NUMBER_UOM: 'NUMBER_UOM', // Textfield number with uom
  NUMBER_DYNAMIC_UOM: 'NUMBER_DYNAMIC_UOM', // Textfield number with uom
  NUMBER_DYNAMIC_CURRENCY: 'NUMBER_DYNAMIC_CURRENCY', // Textfield number with uom
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE', // Radio group
  CHECK_BOX: 'CHECK_BOX', // Checkbox
  MULTIPLE_CHECK_BOXES: 'MULTIPLE_CHECK_BOXES', // Checkbox
  SELECT: 'SELECT', // Dropdown from constants
  SELECT_SINGLE_COWORKER: 'SELECT_SINGLE_COWORKER', // Dropdown from employees of own company
  SELECT_MULTIPLE_COWORKERS: 'SELECT_MULTIPLE_COWORKERS', // Dropdown from employees of own company
  DATE: 'DATE', // Date Selector
  CUSTOM_IDENTIFIER: 'CUSTOM_IDENTIFIER', // Custom ID
};
export const c2cCustomElements = {};
c2cCustomElements.raw = {
  SHORT_TEXT: 'Short text', // Text field
  LONG_TEXT: 'Long text', // Textarea
  NUMBER: 'Number', // Textfield number
  NUMBER_UOM: 'Number with UOM', // Textfield number
  NUMBER_DYNAMIC_UOM: 'Number with Dynamic UOM', // Textfield number
  NUMBER_DYNAMIC_CURRENCY: 'Number with Dynamic Currency Selector', // Textfield number
  MULTIPLE_CHOICE: 'Multiple choice', // Radio group
  CHECK_BOX: 'Check box', // Checkbox
  MULTIPLE_CHECK_BOXES: 'Multiple Check boxes', // Multiple Checkboxes
  SELECT: 'Select Option', // Dropdown
  SELECT_SINGLE_COWORKER: 'Assign single co-worker',
  SELECT_MULTIPLE_COWORKERS: 'Assign multiple co-workers',
  DATE: 'Date',
  CUSTOM_IDENTIFIER: 'Custom Identifier',
};

c2cCustomElements.mapping = { ...c2cCustomElements.raw };
c2cCustomElements.selectArrayOptions = Object.keys(c2cCustomElements.raw)
  .map(k => ({ key: k, text: c2cCustomElements.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
c2cCustomElements.enumMapping = c2cCustomElements.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
c2cCustomElements.mappingArray = Object.keys(c2cCustomElements.raw).map(k => k);

export const c2cSegments = {};
c2cSegments.raw = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
};

c2cSegments.mapping = { ...c2cSegments.raw };
c2cSegments.selectArrayOptions = Object.keys(c2cSegments.raw)
  .map(k => ({ key: k, text: c2cSegments.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
c2cSegments.enumMapping = c2cSegments.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
c2cSegments.mappingArray = Object.keys(c2cSegments.raw).map(k => k);

export const supplierType = {};
supplierType.raw = {
  DIRECT_SUPPLIER: 'Direct supplier',
  INDIRECT_SUPPLIER_SOURCING_AGENCY: 'Indirect supplier via sourcing agency',
  INDIRECT_SUPPLIER_SUBCONTRACTOR: 'Indirect supplier - Subcontractor',
};

supplierType.mapping = { ...supplierType.raw };
supplierType.selectArrayOptions = Object.keys(supplierType.raw)
  .map(k => ({ key: k, text: supplierType.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
supplierType.enumMapping = supplierType.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
supplierType.mappingArray = Object.keys(supplierType.raw).map(k => k);

export const c2cAvailableContantCategories = {};
c2cAvailableContantCategories.raw = {
  FACILITY_PROCESSES: 'Facility processes',
  PRODUCTION_PROCESSES: 'Production processes',
  COMPANY_SEGMENT_CLASSIFICATION: 'Company segment classification',
  SUPPLIER_TYPE: 'Supplier type',
};

c2cAvailableContantCategories.mapping = {
  ...c2cAvailableContantCategories.raw,
};
c2cAvailableContantCategories.selectArrayOptions = Object.keys(
  c2cAvailableContantCategories.raw,
)
  .map(k => ({ key: k, text: c2cAvailableContantCategories.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
c2cAvailableContantCategories.enumMapping =
  c2cAvailableContantCategories.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
c2cAvailableContantCategories.mappingArray = Object.keys(
  c2cAvailableContantCategories.raw,
).map(k => k);

export const TRACING_ORDER_REFRESH_EVENT_ENUM = {
  ORDER_DEPTH: 'ORDER_DEPTH',
  DOCUMENT_PERCENTAGE: 'DOCUMENT_PERCENTAGE',
};

export const TRACING_ORDER_TYPE_ENUM = {
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  SALES_ORDER: 'SALES_ORDER',
};

export const tracingTypes = {};
tracingTypes.raw = {
  PRODUCT_BACKWARD: 'Product Backward',
  FIBER_FORWARD: 'Fiber Forward',
  FIBER_PRODUCT_TRANSFORMATION: 'Fiber Product Transformation',
};
tracingTypes.enumMapping = Object.keys(tracingTypes.raw)
  .map(k => ({ key: k, text: tracingTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

tracingTypes.mapping = { ...tracingTypes.raw };
tracingTypes.selectArrayOptions = Object.keys(tracingTypes.mapping)
  .map(k => ({ key: k, text: `${tracingTypes.mapping[k]}` }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const attachmentTemplateTypes = {};
attachmentTemplateTypes.raw = {
  PRODUCT_BACKWARD: 'Product backward',
  FIBER_FORWARD: 'Fiber forward',
  FIBER_PRODUCT_TRANSFORMATION: 'Production process transformation',
};
attachmentTemplateTypes.enumMapping = Object.keys(attachmentTemplateTypes.raw)
  .map(k => ({ key: k, text: attachmentTemplateTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});
attachmentTemplateTypes.mapping = { ...attachmentTemplateTypes.raw };
attachmentTemplateTypes.selectArrayOptions = Object.keys(
  attachmentTemplateTypes.mapping,
)
  .map(k => ({ key: k, text: `${attachmentTemplateTypes.mapping[k]}` }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const packagingMaterial = {};
packagingMaterial.raw = {
  CARDBOARD: 'Cardboard',
  PLASTIC: 'Plastic',
  OTHER: 'Other',
  UNKNOWN: 'Unknown',
};

packagingMaterial.mapping = { ...packagingMaterial.raw };
packagingMaterial.selectArrayOptions = Object.keys(packagingMaterial.raw)
  .map(k => ({ key: k, text: packagingMaterial.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
packagingMaterial.enumMapping = packagingMaterial.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
packagingMaterial.mappingArray = Object.keys(packagingMaterial.raw).map(k => k);

export const packagingMaterialType = {};
packagingMaterialType.raw = {
  CONVENTIONAL: 'Conventional',
  RECYCLED: 'Recycled',
  OTHER: 'Other',
  UNKNOWN: 'Unknown',
};

packagingMaterialType.mapping = { ...packagingMaterialType.raw };
packagingMaterialType.selectArrayOptions = Object.keys(
  packagingMaterialType.raw,
)
  .map(k => ({ key: k, text: packagingMaterialType.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
packagingMaterialType.enumMapping =
  packagingMaterialType.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
packagingMaterialType.mappingArray = Object.keys(packagingMaterialType.raw).map(
  k => k,
);

export const customerTravelTransportationMode = {};
customerTravelTransportationMode.raw = {
  PUBLIC_BUS: 'Public bus',
  BICYCLE: 'Bicycle',
  CAR: 'Car',
  MOTORCYCLE: 'Motorcycles',
  SUBWAY: 'Subway / Tram',
  OTHER: 'Other',
  UNKNOWN: 'Unknown',
};

customerTravelTransportationMode.mapping = {
  ...customerTravelTransportationMode.raw,
};
customerTravelTransportationMode.selectArrayOptions = Object.keys(
  customerTravelTransportationMode.raw,
)
  .map(k => ({ key: k, text: customerTravelTransportationMode.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
customerTravelTransportationMode.enumMapping =
  customerTravelTransportationMode.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
customerTravelTransportationMode.mappingArray = Object.keys(
  customerTravelTransportationMode.raw,
).map(k => k);

export const engineType = {};
engineType.raw = {
  ELECTRIC: 'Electric',
  DIESEL: 'Diesel',
  PETROL: 'Petrol',
  GAS: 'Gas',
  HYDROGEN: 'Hydrogen',
  OTHER: 'Other',
  UNKNOWN: 'Unknown',
};

engineType.mapping = { ...engineType.raw };
engineType.selectArrayOptions = Object.keys(engineType.raw)
  .map(k => ({ key: k, text: engineType.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
engineType.enumMapping = engineType.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
engineType.mappingArray = Object.keys(engineType.raw).map(k => k);

export const productTravelTransportationMode = {};
productTravelTransportationMode.raw = {
  BICYCLE: 'Bicycle',
  CAR: 'Car',
  MOTORCYCLE: 'Motorcycles',
  DRONE: 'Drones',
  OTHER: 'Other',
  UNKNOWN: 'Unknown',
};

productTravelTransportationMode.mapping = {
  ...productTravelTransportationMode.raw,
};
productTravelTransportationMode.selectArrayOptions = Object.keys(
  productTravelTransportationMode.raw,
)
  .map(k => ({ key: k, text: productTravelTransportationMode.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
productTravelTransportationMode.enumMapping =
  productTravelTransportationMode.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
productTravelTransportationMode.mappingArray = Object.keys(
  productTravelTransportationMode.raw,
).map(k => k);

export const washingType = {};
washingType.raw = {
  MACHINE_WASHING: 'Machine washing',
  HANDWASHING: 'Handwashing',
  UNKNOWN: 'Unknown',
};

washingType.mapping = { ...washingType.raw };
washingType.selectArrayOptions = Object.keys(washingType.raw)
  .map(k => ({ key: k, text: washingType.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
washingType.enumMapping = washingType.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
washingType.mappingArray = Object.keys(washingType.raw).map(k => k);

export const machineWashingType = {};
machineWashingType.raw = {
  NORMAL: 'Normal washing cycle',
  GENTLE: 'Gentle washing cycle',
  OTHER: 'Other',
  UNKNOWN: 'Unknown',
};

machineWashingType.mapping = { ...machineWashingType.raw };
machineWashingType.selectArrayOptions = Object.keys(machineWashingType.raw)
  .map(k => ({ key: k, text: machineWashingType.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
machineWashingType.enumMapping = machineWashingType.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
machineWashingType.mappingArray = Object.keys(machineWashingType.raw).map(
  k => k,
);

export const washingTemperature = {};
washingTemperature.raw = {
  THIRTY_CELCIUS: '30° Celsius',
  FORTY_CELCIUS: '40° Celsius',
  SIXTY_CELCIUS: '60° Celsius',
  NINETY_CELCIUS: '90° Celsius',
  OTHER: 'Other',
  UNKNOWN: 'Unknown',
};

washingTemperature.mapping = { ...washingTemperature.raw };
washingTemperature.selectArrayOptions = Object.keys(washingTemperature.raw)
  .map(k => ({ key: k, text: washingTemperature.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
washingTemperature.enumMapping = washingTemperature.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
washingTemperature.mappingArray = Object.keys(washingTemperature.raw).map(
  k => k,
);

export const ironingTemperature = {};
ironingTemperature.raw = {
  HUNDRED_TEN_CELCIUS: '110° Celsius',
  HUNDRED_FIFTY_CELCIUS: '150° Celsius',
  TWO_HUNDRED_CELCIUS: '200° Celsius',
  OTHER: 'Other',
  UNKNOWN: 'Unknown',
};

ironingTemperature.mapping = { ...ironingTemperature.raw };
ironingTemperature.selectArrayOptions = Object.keys(ironingTemperature.raw)
  .map(k => ({ key: k, text: ironingTemperature.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
ironingTemperature.enumMapping = ironingTemperature.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);
ironingTemperature.mappingArray = Object.keys(ironingTemperature.raw).map(
  k => k,
);

export const TABLE_ASSET_TYPES = {
  PRODUCT_CATEGORIES: 'PRODUCT_CATEGORIES',
};

export const FIBER_SETTINGS = {
  FACILITY_CAN_DO_NEW_INCOMING_TRANSACTION:
    'FACILITY_CAN_DO_NEW_INCOMING_TRANSACTION',
  FACILITY_CAN_DO_OUTGOING_TRANSACTION_WITHOUT_STOCK:
    'FACILITY_CAN_DO_OUTGOING_TRANSACTION_WITHOUT_STOCK',
};

export const FIBER_TRANSACTION_TYPES = {
  OUTGOING: 'OUTGOING',
  INCOMING: 'INCOMING',
};

export const PRODUCTION_PROCESSES = [
  {
    title: 'Origin',
    description: 'Creation of raw materials',
  },
  {
    title: 'Material Processing',
    description: 'Transformation of raw material into yarn',
  },
  {
    title: 'Fabric Creation',
    description: 'Transformation of yarn into fabric',
  },
  {
    title: 'Manufacturing',
    description: 'Creation of the end-consumer product',
  },
  {
    title: 'Retail',
    description: 'Selling of end-consumer product',
  },
  {
    title: 'Warehouse',
    description: 'Storage and logistics until the point of sale',
  },
];

export const classificationImpactAreasRelationTypes = {};
classificationImpactAreasRelationTypes.raw = {
  GLOBAL_INFORMATION: 'Global Information',
  ECO_FOOTPRINT: 'Eco Footprint',
};

classificationImpactAreasRelationTypes.mapping = {
  ...classificationImpactAreasRelationTypes.raw,
};
classificationImpactAreasRelationTypes.selectArrayOptions = Object.keys(
  classificationImpactAreasRelationTypes.raw,
)
  .map(k => ({ key: k, text: classificationImpactAreasRelationTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
classificationImpactAreasRelationTypes.enumMapping =
  classificationImpactAreasRelationTypes.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
classificationImpactAreasRelationTypes.mappingArray = Object.keys(
  classificationImpactAreasRelationTypes.raw,
).map(k => k);

export const impactAreasRootNodes = {};
impactAreasRootNodes.raw = {
  ESG: 'ESG',
};
impactAreasRootNodes.mapping = { ...impactAreasRootNodes.raw };

export const companyDataFieldsTypes = {};
companyDataFieldsTypes.raw = {
  STRING: 'Text',
  NUMBER: 'Number',
  NUMBER_UOM: 'Number with UOM',
  NUMBER_DYNAMIC_UOM: 'Number with Dynamic UOM',
  NUMBER_DYNAMIC_CURRENCY: 'Number with Dynamic Currency Selector',
  FILE_UPLOAD: 'File Upload',
  DATE: 'Date',
  SELECT: 'Select',
  MULTI_SELECT: 'Multi-Select',
  TABLE: 'Table',
  TOGGLE: 'Toggle',
  SHORT_TEXT: 'Short text',
  LONG_TEXT: 'Long text',
  VIDEO: 'video',
  MULTIPLE_PHOTO_UPLOAD: 'multiple_photo_upload',
  VIDEO_UPLOAD: 'video_upload',
  ADDRESS: 'Address',
  NUMBER_DYNAMIC_UOM_WITH_YEAR: 'Number with Dynamic UOM and Date',
  NUMBER_DYNAMIC_CURRENCY_WITH_YEAR:
    'Number with Dynamic Currency Selector and Date',
  SELECT_YEAR: 'Select Year',
  YES_NO: 'Yes/No',
  BOOLEAN: 'Boolean',
  CHECK_BOX: 'Check box',
  SELECT_WITH_FOLLOW_UP: 'Select with follow up',
};

companyDataFieldsTypes.mapping = { ...companyDataFieldsTypes.raw };
companyDataFieldsTypes.selectArrayOptions = Object.keys(
  companyDataFieldsTypes.raw,
)
  .map(k => ({ key: k, text: companyDataFieldsTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
companyDataFieldsTypes.enumMapping =
  companyDataFieldsTypes.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
companyDataFieldsTypes.mappingArray = Object.keys(
  companyDataFieldsTypes.raw,
).map(k => k);

export const preDefinedSelectTypes = {};
preDefinedSelectTypes.raw = {
  COUNTRIES: 'Countries',
  LANGUAGES: 'Languages',
  FACILITY_PROCESSES: 'Facility Processes',
};

preDefinedSelectTypes.mapping = { ...preDefinedSelectTypes.raw };
preDefinedSelectTypes.selectArrayOptions = Object.keys(
  preDefinedSelectTypes.raw,
)
  .map(k => ({ key: k, text: preDefinedSelectTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
preDefinedSelectTypes.enumMapping =
  preDefinedSelectTypes.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );
preDefinedSelectTypes.mappingArray = Object.keys(preDefinedSelectTypes.raw).map(
  k => k,
);

export const certificateStandardProvider = {};
certificateStandardProvider.raw = {
  OEKO_TEX: 'OEKO_TEX',
};

certificateStandardProvider.mapping = { ...certificateStandardProvider.raw };
certificateStandardProvider.readableName = { OEKO_TEX: 'Oeko-Tex' };
certificateStandardProvider.selectArrayOptions = Object.keys(
  certificateStandardProvider.mapping,
).map(k => ({
  key: k,
  text: certificateStandardProvider.mapping[k],
}));

export const companyDynamicTabs = { viewVisibilities: {} };

companyDynamicTabs.viewVisibilities.raw = {
  private: 'Private',
  network: 'Network',
  public: 'Public',
};
companyDynamicTabs.viewVisibilities.selectArrayOptions = Object.entries(
  companyDynamicTabs.viewVisibilities.raw,
).map(f => ({ key: f[0], text: f[1] }));
export const ROWS_PER_PAGE_SELECTOR = [10, 15, 50, 100, 500];

export const CERTIFICATE_STANDARD_VERIFIED_BY = {
  LICENSE_NUMBER: 'LICENSE_NUMBER',
  DOCUMENT_NUMBER: 'DOCUMENT_NUMBER',
};

export const FIELDS = {
  SELECT: 'Select', // Select field
  SHORT_TEXT: 'Short text', // Text field
  LONG_TEXT: 'Long text', // Textarea
  NUMBER: 'Number', // Textfield number
  MULTI_SELECT: 'Multi select',
  DATE: 'date',
  DATE_RANGE: 'Date range',
  YEAR_PICKER: 'Year picker',
};

export const capaTypes = {};
capaTypes.raw = {
  CAP: 'CAP',
  CAPA: 'CAPA',
};

capaTypes.mapping = { ...capaTypes.raw };
capaTypes.selectArrayOptions = Object.keys(capaTypes.raw)
  .map(k => ({ key: k, text: capaTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaTypes.enumMapping = capaTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const capaSubTypes = {};

capaSubTypes.raw = {
  CAP: 'CAP',
  CA: 'Corrective Action',
  PA: 'Preventive Action',
};

capaSubTypes.mapping = { ...capaSubTypes.raw };
capaSubTypes.selectArrayOptions = Object.keys(capaSubTypes.raw)
  .map(k => ({ key: k, text: capaSubTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaSubTypes.nuvoImporterDropdownOptions = Object.keys(capaSubTypes.raw).map(
  k => ({
    label: capaSubTypes.raw[k],
    value: k,
    type: 'string',
  }),
);
capaSubTypes.enumMapping = capaSubTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const capaStatus = {};
capaStatus.raw = {
  TO_DO: 'To Do',
  IN_PROGRESS: 'In Progress',
  BLOCKED: 'Blocked',
  IN_REVIEW: 'In review',
  CHANGES_REQUESTED: 'Changes Requested',
  DONE: 'Done',
};

capaStatus.mapping = { ...capaStatus.raw };
capaStatus.selectArrayOptions = Object.keys(capaStatus.raw)
  .map(k => ({ key: k, text: capaStatus.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaStatus.nuvoImporterDropdownOptions = Object.keys(capaStatus.raw).map(k => ({
  label: capaStatus.raw[k],
  value: k,
  type: 'string',
}));
capaStatus.enumMapping = capaStatus.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const riskAssessmentsStatus = {};
riskAssessmentsStatus.raw = {
  EXTREME: 'Extreme',
  HIGH: 'High',
  MEDIUM: 'Medium',
  MODERATE: 'Moderate',
  LOW: 'Low',
};
riskAssessmentsStatus.mapping = { ...riskAssessmentsStatus.raw };
riskAssessmentsStatus.selectArrayOptions = Object.keys(
  riskAssessmentsStatus.raw,
)
  .map(k => ({ key: k, text: riskAssessmentsStatus.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
riskAssessmentsStatus.enumMapping =
  riskAssessmentsStatus.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const capaSourceTypes = {};
capaSourceTypes.raw = {
  AUDIT: 'Audit',
};

capaSourceTypes.mapping = { ...capaSourceTypes.raw };
capaSourceTypes.selectArrayOptions = Object.keys(capaSourceTypes.raw)
  .map(k => ({ key: k, text: capaSourceTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaSourceTypes.nuvoImporterDropdownOptions = Object.keys(
  capaSourceTypes.raw,
).map(k => ({
  label: capaSourceTypes.raw[k],
  value: k,
  type: 'string',
}));
capaSourceTypes.enumMapping = capaSourceTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const capaUrgency = {};
capaUrgency.raw = {
  A: 'Minor',
  B: 'Moderate',
  C: 'Major',
  D: 'Critical',
  E: 'Zero Tolerance',
};

capaUrgency.mapping = { ...capaUrgency.raw };
capaUrgency.selectArrayOptions = Object.keys(capaUrgency.raw).map(k => ({
  key: k,
  text: capaUrgency.raw[k],
}));
capaUrgency.nuvoImporterDropdownOptions = Object.keys(capaUrgency.raw).map(
  k => ({
    label: capaUrgency.raw[k],
    value: k,
    type: 'string',
  }),
);
capaUrgency.enumMapping = capaUrgency.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const auditFindingCreateUrgencies = {};
auditFindingCreateUrgencies.raw = {
  A: 'Minor',
  B: 'Moderate',
  C: 'Major',
  D: 'Critical',
  E: 'Zero Tolerance',
};

auditFindingCreateUrgencies.selectArrayOptions = Object.keys(
  auditFindingCreateUrgencies.raw,
).map(k => ({
  key: k,
  text: auditFindingCreateUrgencies.raw[k],
}));

export const mappedCapaUrgency = {};
mappedCapaUrgency.raw = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
};

mappedCapaUrgency.selectArrayOptions = Object.keys(mappedCapaUrgency.raw).map(
  k => ({
    key: k,
    text: mappedCapaUrgency.raw[k],
  }),
);

export const capaAdditionalFields = {};
capaAdditionalFields.raw = {
  auditor: 'Auditor',
  finding: 'Finding',
  goals: 'Goals',
  managementResponse: 'Management Response',
  recommendation: 'Recommendation',
  requirement: 'Requirement',
  rootCause: 'Root Cause',
};

capaAdditionalFields.mapping = { ...capaAdditionalFields.raw };
capaAdditionalFields.selectArrayOptions = Object.keys(capaAdditionalFields.raw)
  .map(k => ({ key: k, text: capaAdditionalFields.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaAdditionalFields.enumMapping =
  capaAdditionalFields.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const capaAdditionalFieldsPlaceholder = {};
capaAdditionalFieldsPlaceholder.raw = {
  requirement: 'Reference any law, policy or other binding document',
};

export const capaActionUserTypes = {};
capaActionUserTypes.raw = {
  ASSIGNEE: 'ASSIGNEE',
  REPORTER: 'REPORTER',
  WATCHER: 'WATCHER',
};

capaActionUserTypes.mapping = { ...capaActionUserTypes.raw };
capaActionUserTypes.selectArrayOptions = Object.keys(capaActionUserTypes.raw)
  .map(k => ({ key: k, text: capaActionUserTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaActionUserTypes.enumMapping = capaActionUserTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const capaActionCompanyTypes = {};
capaActionCompanyTypes.raw = {
  OWNER: 'OWNER',
  CREATOR: 'CREATOR',
  COLLABORATOR: 'COLLABORATOR',
};

capaActionCompanyTypes.mapping = { ...capaActionCompanyTypes.raw };
capaActionCompanyTypes.selectArrayOptions = Object.keys(
  capaActionCompanyTypes.raw,
)
  .map(k => ({ key: k, text: capaActionCompanyTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaActionCompanyTypes.enumMapping =
  capaActionCompanyTypes.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const capaActionActionsTypes = {};
capaActionActionsTypes.raw = {
  CHILD: 'Child',
};

capaActionActionsTypes.mapping = { ...capaActionActionsTypes.raw };
capaActionActionsTypes.selectArrayOptions = Object.keys(
  capaActionActionsTypes.raw,
)
  .map(k => ({ key: k, text: capaActionActionsTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaActionActionsTypes.enumMapping =
  capaActionActionsTypes.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const productStoryTracingTypes = {};
productStoryTracingTypes.raw = {
  TRACING_PURCHASE_ORDERS: 'Purchase orders',
  TRACING_SALES_ORDERS: 'Sales orders',
  SUPPLY_CHAINS: 'Supply chain',
  SUPPLY_CHAIN_MAPPINGS: 'Product mapping',
  CASCADE_MAPPINGS: 'Supply chain mapping',
};
productStoryTracingTypes.enumMapping = Object.keys(productStoryTracingTypes.raw)
  .map(k => ({ key: k, text: productStoryTracingTypes.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

export const ORDER_HELPER_TEXTS = {
  FACILITY_PROCESS:
    'The facility processes for the buying and selling companies should be aligned to the process related to the order.',
  SALES_ORDER_NUMBER:
    'Your sales order number is your one-of-a-kind identifier that you assign to your order.',
  PRODUCT_LINES:
    'The products that you should select are the products the buying company is acquiring.',
  PURCHASE_ORDER_NUMBER:
    'Your purchase order number is your one-of-a-kind identifier that you assign to your order.',
};

export const capaExternalTabs = {};
capaExternalTabs.raw = {
  AUDIT: 'AUDIT',
  ACTION_POINTS: 'ACTION_POINTS',
  COMPANY_PROFILE: 'COMPANY_PROFILE',
};

export const capaColumnNames = {
  AUDIT_OWN: `${capaExternalTabs.raw.AUDIT}_OWN`,
  AUDIT_COLLABORATING: `${capaExternalTabs.raw.AUDIT}_COLLABORATING`,
  CAPA_OWN: `${capaTypes.enumMapping.CAPA}_OWN`,
  CAP_OWN: `${capaTypes.enumMapping.CAP}_OWN`,
  CAPA_COLLABORATING: `${capaTypes.enumMapping.CAPA}_COLLABORATING`,
  CAP_COLLABORATING: `${capaTypes.enumMapping.CAP}_COLLABORATING`,
  COMPANY_PROFILE_OWN: `${capaExternalTabs.raw.COMPANY_PROFILE}_OWN`,
  COMPANY_PROFILE_COLLABORATING: `${capaExternalTabs.raw.COMPANY_PROFILE}_COLLABORATING`,
};

export const capaActionCommentsTab = {};
capaActionCommentsTab.raw = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  ADMINNOTE: 'ADMINNOTE',
};

export const SUPPLY_CHAIN_STATUS = {
  owner: 'Owner',
  collaborator: 'Collaborator',
};

export const AUDIT_PRIVACY_STATUS_ENUM = {
  PUBLIC: 'public',
  SHARED_TO: 'shared_to',
  SHARED_BY: 'shared_by',
  PRIVATE: 'private',
  PRIVATE_REQUESTS: 'private_requests',
  SHARED: 'shared',
  REQUESTED: 'requested',
  NONE: 'none',
};

export const PLATFORM_FEATURES_ENUM = {
  AUDIT_RECORDS: 'audit_records',
  CASCADE_TRACING: 'cascade-tracing',
  COMPANY_ESG_EXPORT: 'company_esg_export',
  CONSTANTS_MAPPING: 'constants-mapping',
  CUSTOM_INFORMATION_FIELDS: 'custom-information-fields',
  DYNAMIC_DATA_FIELDS: 'dynamic-data-fields',
  EXPORT_PRODUCT_LIST: 'export-product-list',
  EXTERNAL_MANAGEMENT: 'external-management',
  FIBER_FORWARD: 'fiber-forward',
  FIBER_FORWARD_TRACING_GRAPH: 'fiber-forward:tracing-graph',
  INCOMING_TRANSACTION_UPLOAD: 'incoming-transaction-upload',
  KHARON_ENTITY_LIST: 'kharon-entity-list',
  NETWORK_COMPANIES_GRAPH: 'network-companies-graph',
  OUTGOING_TRANSACTION_UPLOAD: 'outgoing-transaction-upload',
  PRODUCT_CONSUMER_LIFESTAGE: 'product-consumer-lifestage',
  RISK_ANALYSIS: 'risk-analysis',
  SELF_SERVICE_API_KEY: 'self-service-api-key',
  SUPPLY_CHAIN_MAPPING: 'supply-chain-mapping',
  VIEW_NETWORK_USERS_INFO: 'view-network-users-info',
  AUDIT_AI: 'audit-ai',
  COMPANY_SERVICE: 'company-service',
  COMPANY_PROFILES: 'company-profiles',
  SUPPLIER_QUESTIONNAIRE: 'supplier_questionnaire',
  SLCP_ASSESSMENT: 'slcp-assessment',
  CAPA_V2: 'capa-v2',
  TRACING_AI: 'tracing-ai',
  CERTIFIED_MATERIALS_MANAGEMENT: 'certified-materials-management',
  SUPPLY_CHAIN_MAPPING_PRODUCT_STORY: 'supply-chain-mapping-product-story',
  PRODUCT_MAPPING: 'product-mapping',
  ENTITY_SCREENING_V2: 'entity-screening-v2',
  KHARON_V2: 'kharon-v2',
  DROP_BOX: 'drop_box',
  SLCP_ACTIVE_HOST: 'slcp-active-host',
  ORDER_HUB: 'order-hub',
};

export const QUESTIONNAIRE_ANSWER_TYPE_MODES_ENUM = {
  BUILDER: 'builder',
  ANSWER: 'answer',
  PREVIEW: 'preview',
  REVIEW: 'review',
};

export const CERTIFICATE_STATUS_ENUM = {
  IN_REVIEW: 'REQUESTED',
  REJECTED: 'DRAFT',
  NOT_VERIFIABLE: 'NOT_VERIFIABLE',
  APPROVED: 'APPROVED',
};

export const CERTIFICATE_STATUS_MAPPING = {
  [CERTIFICATE_STATUS_ENUM.IN_REVIEW]: 'In review',
  [CERTIFICATE_STATUS_ENUM.REJECTED]: 'Rejected',
  [CERTIFICATE_STATUS_ENUM.NOT_VERIFIABLE]: 'Not Verifiable',
  [CERTIFICATE_STATUS_ENUM.APPROVED]: 'Approved',
};

export const CERTIFICATE_STATUS_TRANSLATION_MAPPING = {
  [CERTIFICATE_STATUS_ENUM.IN_REVIEW]: 'certificate.infoHeader.inReview',
  [CERTIFICATE_STATUS_ENUM.REJECTED]: 'certificate.infoHeader.rejected',
  [CERTIFICATE_STATUS_ENUM.NOT_VERIFIABLE]:
    'certificate.infoHeader.notVerifiable',
  [CERTIFICATE_STATUS_ENUM.APPROVED]: 'certificate.infoHeader.approved',
};

export const CERTIFICATE_STATUS_COLOR_CLASS_MAPPING = {
  [CERTIFICATE_STATUS_ENUM.IN_REVIEW]: '',
  [CERTIFICATE_STATUS_ENUM.REJECTED]: 'danger',
  [CERTIFICATE_STATUS_ENUM.NOT_VERIFIABLE]: 'primary',
  [CERTIFICATE_STATUS_ENUM.APPROVED]: 'secondary',
};

export const CUT_MAKE_TRIM_MATCHES = {
  CUT: 'Cut',
  MAKE: 'Make',
  TRIM: 'Trim',
  CMT: 'CMT',
};

export const productPropertyCategories = {};
productPropertyCategories.raw = {
  DEPARTMENTS: 'departments',
  BRANDS: 'brands',
  SEASONS: 'seasons',
};
productPropertyCategories.enumMapping = Object.keys(
  productPropertyCategories.raw,
)
  .map(k => ({ key: k, text: productPropertyCategories.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

export const riskAssessmentVisibility = {};
riskAssessmentVisibility.raw = {
  PRIVATE: 'Private',
  PUBLIC: 'Public',
  RETRACED: 'Retraced',
};
riskAssessmentVisibility.selectArrayOptions = Object.keys(
  riskAssessmentVisibility.raw,
)
  .filter(k => k !== 'RETRACED')
  .map(k => ({ key: k, text: riskAssessmentVisibility.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
riskAssessmentVisibility.mapping =
  riskAssessmentVisibility.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const likelihoodFormulaIds = {};
likelihoodFormulaIds.raw = {
  documentExists: 'Document',
  certificateExists: 'Certificate',
  auditExists: 'Audit',
};
likelihoodFormulaIds.selectArrayOptions = Object.keys(likelihoodFormulaIds.raw)
  .map(k => ({ key: k, text: likelihoodFormulaIds.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
likelihoodFormulaIds.mapping = likelihoodFormulaIds.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const severityFormulaIds = {};
severityFormulaIds.raw = {
  companySize: 'Company size',
  facilityProcesses: 'Facility Processes',
};
severityFormulaIds.selectArrayOptions = Object.keys(severityFormulaIds.raw)
  .map(k => ({ key: k, text: severityFormulaIds.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
severityFormulaIds.mapping = severityFormulaIds.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const severityOptions = [
  { key: 1, title: '1' },
  { key: 2, title: '2' },
  { key: 3, title: '3' },
  { key: 4, title: '4' },
  { key: 5, title: '5' },
];

export const likelihoodOptions = [
  { key: 1, title: 'Low' },
  { key: 2, title: 'Moderate' },
  { key: 3, title: 'Medium' },
  { key: 4, title: 'High' },
  { key: 5, title: 'Extreme' },
];

export const riskStatuses = {};
riskStatuses.raw = {
  CALCULATING: 'CALCULATING',
  READY: 'READY',
  OUT_DATED: 'OUT_DATED',
  CREATED: 'CREATED',
  FAILED: 'FAILED',
};
riskStatuses.selectArrayOptions = Object.keys(riskStatuses.raw)
  .map(k => ({ key: k, text: riskStatuses.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const capaUrgencyAuditMapping = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
};

export const AUDITS_DATA_STATUS_ENUM = {
  IN_PROGRESS: 'IN_PROGRESS',
  IN_REVIEW: 'IN_REVIEW',
  READY: 'READY',
};

export const AUDITS_AI_ACTIONS_ENUM = {
  SUGGESTIONS_REVIEWED: 'SUGGESTIONS_REVIEWED',
  CAPAS_CREATED: 'CAPAS_CREATED',
};

export const ASSESSMENT_STATUS_ENUM = {
  READY: 'READY',
  FAILED: 'FAILED',
  CALCULATING: 'CALCULATING',
  CREATED: 'CREATED',
  OUT_DATED: 'OUT_DATED',
};

export const ASSESSMENT_STATUSES = {
  READY: 'assessmentDetails.table.column.status.ready',
  FAILED: 'assessmentDetails.table.column.status.failed',
  CALCULATING: 'assessmentDetails.table.column.status.calculating',
  PENDING: 'assessmentDetails.table.column.status.pending',
  CREATED: 'assessmentDetails.table.column.status.created',
  OUT_DATED: 'assessmentDetails.table.column.status.outdated',
};

export const PROFILE_TEMPLATES = {
  ABOUT: 'ABOUT',
  ENERGY: 'ENERGY',
  GHG_EMISSIONS: 'GHG_EMISSIONS',
  GOVERNMENT_PROGRAM: 'GOVERNMENT_PROGRAM',
  OPERATIONAL_METRICS: 'OPERATIONAL_METRICS',
  OTHER_IDS: 'OTHER_IDS',
  SUPERVISORS: 'SUPERVISORS',
  WASTE: 'WASTE',
  WASTE_WATER: 'WASTE_WATER',
  WATER: 'WATER',
  WORKERS: 'WORKERS',
  AUDITS: 'AUDITS',
};

export const RULE_TEMPLATE_VIEW_ENUM = {
  CUSTOM: 'CUSTOM',
  RETRACED: 'RETRACED',
};

export const RULE_TEMPLATE_STATUS_ENUM = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
};

export const RISK_ASSESSMENT_VISIBILITY_ENUM = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
  RETRACED: 'RETRACED',
};

export const supportedAuditIdsForAi = [
  'BSCI',
  'FAIR_WEAR_FOUNDATION',
  'SEDEX_SMETA',
  'ELEVATE',
];

export const AUDIT_FINDINGS_SOURCE_MAPPING = {
  AI_GENERATED: {
    text: 'AI generated',
    color: '',
  },
  USER_GENERATED: {
    text: 'User generated',
    color: 'primary',
  },
};

export const AI_PROCESS_TYPES = {
  AUDIT_FIELDS: 'AUDIT_FIELDS',
  AUDIT_FINDINGS: 'AUDIT_FINDINGS',
};

export const MANUAL_MITIGATION_FIELDS = {
  LIKELIHOOD: 'LIKELIHOOD',
  SEVERITY: 'SEVERITY',
};

export const DEVELOPMENT_TAGS = {
  EXPERIMENTAL: 'Experimental',
  ALPHA: 'Alpha',
  BETA: 'Beta',
};

export const DEVELOPMENT_TAGS_ENUM = Object.keys(DEVELOPMENT_TAGS).reduce(
  (acc, key) => ({ ...acc, [key]: key }),
  {},
);

export const developmentTagsSelectArrayOptions = Object.keys(
  DEVELOPMENT_TAGS_ENUM,
)
  .map(k => ({ key: k, text: DEVELOPMENT_TAGS[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const ACTIVE_DEVELOPMENT_TAGS = {
  AUDIT_AI: 'audit-ai',
};

export const ACTIVE_EXPERIMENTAL_TAGS = {
  GREEN_PATH: 'green-path',
};

export const PROFILE_TEMPLATES_META = [
  { key: 'ABOUT', text: 'About', fontIcon: 'fa-building' },
  { key: 'ENERGY', text: 'Energy', fontIcon: 'fa-globe' },
  { key: 'GHG_EMISSIONS', text: 'GHG Emissions', fontIcon: 'fa-globe' },
  {
    key: 'GOVERNMENT_PROGRAM',
    text: 'Government Program',
    fontIcon: 'fa-book',
  },
  {
    key: 'OPERATIONAL_METRICS',
    text: 'Operational Metrics',
    fontIcon: 'fa-hand-sparkles',
  },
  { key: 'OTHER_IDS', text: 'Other Ids', fontIcon: 'fa-hand-sparkles' },
  { key: 'SUPERVISORS', text: 'Supervisors', fontIcon: 'fa-hand-sparkles' },
  { key: 'WASTE', text: 'Waste', fontIcon: 'fa-globe' },
  { key: 'WASTE_WATER', text: 'Waste Water', fontIcon: 'fa-globe' },
  { key: 'WATER', text: 'Water', fontIcon: 'fa-globe' },
  { key: 'WORKERS', text: 'Workers', fontIcon: 'fa-globe' },
  {
    key: 'WORKER_DEMOGRAPHICS',
    text: 'Worker Demographics',
    fontIcon: 'fa-globe',
  },
  { key: 'WATER_MANAGEMENT', text: 'Water Management', fontIcon: 'fa-globe' },
  {
    key: 'WASTE_WATER_MANAGEMENT',
    text: 'Water Water Management',
    fontIcon: 'fa-globe',
  },
  { key: 'WASTE_STREAMS', text: 'Water Streams', fontIcon: 'fa-globe' },
  { key: 'ENERGY_SOURCES', text: 'Energy Sources', fontIcon: 'fa-globe' },
];

export const QUESTIONNAIRE_TABLE_TYPE_MAPPING = {
  WASTE_WATER_TREATMENT_PROFICIENCY: 'waste_water_treatment_proficiency',
  WASTE_SOURCES: 'waste_sources',
  GHG_EMISSIONS_OFFSET_SCOPE: 'ghg_emissions_offset_scope',
  CARBON_INTENSITY_SCOPE: 'carbon_intensity_scope',
  ENERGY_SOURCES_PEFCR: 'energy_sources_pefcr',
  WATER_SOURCES: 'water_sources',
  NATIONALITIES: 'nationalities',
};

export const QUESTIONNAIRE_REQUEST_STATUS_MAPPING = {
  OPEN: 'open',
  IN_REVIEW: 'view',
  REQUEST_CHANGES: 'update',
  COMPLETED: 'view',
};

export const DEFAULT_SECTION_NAME = {
  SECTION_ONE: 'Section One',
};

export const RISK_RULE_METRIC_OPTIONS = [
  {
    key: 'LIKELIHOOD',
    text: 'Likelihood for',
  },
  {
    key: 'SEVERITY',
    text: 'Severity for',
  },
];

export const RISK_ASSET_TYPES = {
  AUDITS: 'AUDITS',
  AUDIT_FINDINGS: 'AUDIT_FINDINGS',
  CERTIFICATES: 'CERTIFICATES',
  COMPANY_DOCUMENTS: 'COMPANY_DOCUMENTS',
  COMPANY_PROFILES: 'COMPANY_PROFILES',
};

export const COMPANY_PROFILE_TYPES = {
  COMPANY_SIZE: 'COMPANY_SIZE',
  FACILITY_PROCESSES: 'FACILITY_PROCESSES',
  PRODUCT_TYPES: 'PRODUCT_TYPES',
  PRODUCTION_PROCESSES: 'PRODUCTION_PROCESSES',
  NUMBER_OF_PRODUCTION_SITES: 'NUMBER_OF_PRODUCTION_SITES',
  COUNTRY: 'COUNTRY',
  RELATIONSHIP_TYPE: 'RELATIONSHIP_TYPE',
};

export const AUDIT_FINDINGS_TYPES = {
  IMPACT_AREAS: 'IMPACT_AREAS',
};

export const STATUS_BUTTON_COLOUR = {
  IN_REVIEW: 'warning',
  COMPLETED: 'success',
  REQUEST_CHANGES: 'danger',
  OPEN: 'primary',
};

export const RISK_LANDSCAPE_PINNED_COLUMNS = {
  COUNTRIES: ['country', 'riskLevel', 'grossRisk'],
  COMPANIES: [
    'featuredImageFileUrl',
    'companyName',
    'relationshipType',
    'country',
    'facilityProcesses',
    'riskLevel',
    'grossCountryAverageLikelihoodScore',
    'companyAverageLikelihoodScore',
    'companyAveragePriorityScore',
  ],
};

export const RISK_LANDSCAPE_TABLE_NAMES = {
  COUNTRIES: 'risk-country-details-list',
  COMPANIES: 'risk-company-details-list',
  RISKS: 'risk-list',
};

export const RISK_ASSESSMENT_TYPES = {
  SYSTEM: 'SYSTEM',
  USER: 'USER',
};

export const RETRACED_STANDARD_BLUEPRINT = 'RETRACED_STANDARD_TEMPLATE';

export const ruleTemplateStatuses = {};
ruleTemplateStatuses.raw = {
  PUBLISHED: 'Published',
  DRAFT: 'Draft',
};

export const RISK_PROFILE_TABLE_NAMES = {
  RISKS_PRIORITIZATION: 'risk-priorotization-list',
};

export const supplyChainTier = {};
supplyChainTier.enum =
  dataPoints.getDataPointById('supply_chain_tier')?.dataPointDefinition
    ?.options ?? [];
supplyChainTier.raw = supplyChainTier.enum?.length
  ? Object.fromEntries(supplyChainTier.enum.map(item => [item.key, item.text]))
  : {
      TIER_1: 'Tier 1',
      TIER_2: 'Tier 2',
      TIER_3: 'Tier 3',
      TIER_4: 'Tier 4',
      TIER_5: 'Tier 5',
    };
supplyChainTier.mapping = { ...supplyChainTier.raw };
supplyChainTier.selectArrayOptions = Object.keys(supplyChainTier.mapping).map(
  k => ({
    key: k,
    text: supplyChainTier.mapping[k],
  }),
);
supplyChainTier.selectOptions = Object.keys(supplyChainTier.mapping).map(k => ({
  id: k,
  name: supplyChainTier.mapping[k],
}));
supplyChainTier.enumMapping = supplyChainTier.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const CASCADE_MAPPING_COMPANY_DISABLING_REASON_CODES = {
  'ALREADY-INVITED': 'alreadyInvited',
  'ALREADY-COLLABORATING': 'alreadyCollaborating',
  'ZERO-USER-COUNT': 'zeroUserCount',
};

export const CASCADE_MAPPING_COLLABORATOR_RIGHTS = {
  CREATOR: 'Creator',
};

export const ASSESSMENT_BLUEPRINT_COMPANY_DISABLING_REASON_CODES = {
  ALREADY_EXISTS: 'alreadyExists',
  UNDEFINED_COMPANY_LEVERAGE: 'undefinedCompanyLeverage',
};

export const ASSESSMENT_TRIGGER = {
  INITIAL_CALCULATION:
    'assessmentDetails.table.column.trigger.initialAssessment',
  AUDITS_ACCESS_SHARED:
    'assessmentDetails.table.column.trigger.auditAccessShared',
  AUDITS_ACCESS_REMOVED:
    'assessmentDetails.table.column.trigger.auditAccessRemoved',
  AUDITS_ACCESS_UPDATED:
    'assessmentDetails.table.column.trigger.auditAccessUpdated',
  AUDITS_WITH_FINDINGS_ACCESS_SHARED:
    'assessmentDetails.table.column.trigger.auditFindingAccessShared',
  AUDITS_WITH_FINDINGS_ACCESS_REMOVED:
    'assessmentDetails.table.column.trigger.auditFindingAccessRemoved',
  AUDITS_WITH_FINDINGS_ACCESS_UPDATED:
    'assessmentDetails.table.column.trigger.auditFindingAccessUpdated',
  CERTIFICATE_ARCHIVED:
    'assessmentDetails.table.column.trigger.certificateArchived',
  CERTIFICATE_DELETED:
    'assessmentDetails.table.column.trigger.certificateDeleted',
  CERTIFICATE_EXPIRED:
    'assessmentDetails.table.column.trigger.certificateExpired',
  CERTIFICATE_UPDATED:
    'assessmentDetails.table.column.trigger.certificateUpdated',
  CERTIFICATE_UPLOADED:
    'assessmentDetails.table.column.trigger.certificateUploaded',
  DOCUMENT_ARCHIVED: 'assessmentDetails.table.column.trigger.documentArchived',
  DOCUMENT_SHARED: 'assessmentDetails.table.column.trigger.documentShared',
  DOCUMENT_UPDATED: 'assessmentDetails.table.column.trigger.documentUpdated',
  DOCUMENT_UPLOADED: 'assessmentDetails.table.column.trigger.documentUploaded',
  MANUAL_MITIGATION: 'assessmentDetails.table.column.trigger.manualMitigation',
  MANUAL_RECALCULATION:
    'assessmentDetails.table.column.trigger.manualRecalculation',
  PROFILE_UPDATED: 'assessmentDetails.table.column.trigger.profileUpdated',
};

export const assessmentArchiveFilterOptions = [
  { key: '1', text: 'Yes' },
  { key: '0', text: 'No' },
];

export const datapointIdsWithParentOptions = [
  'facility_processes',
  'product_types',
];

export const dataPointHiddenFields = ['country_name'];
export const dataPointDisabledFields = ['retraced_risk_score'];
export const dataPointWithFixedDecimals = ['retraced_risk_score'];

export const CASCADE_MAPPING_ARCHIVE_VIEW_ENUM = {
  ARCHIVED_COMPANY_CHAINS: 'ARCHIVED_COMPANY_CHAINS',
};

export const BASE_PATH = {
  COMPANY_MANAGEMENT: '/management/companies',
  FILES_MANAGEMENT: '/management/files',
};

export const DASHBOARD_ANALYTICS_EXPORT_DATASET_TYPES = {
  PURCHASE_ORDERS: 'PURCHASE_ORDERS',
  TRACING: 'TRACING',
};

export const AUDIT_TYPES = {
  CHEMICAL_AUDIT: 'Chemical',
  ENVIRONMENTAL_AUDIT: 'Environmental',
  SOCIAL_AUDIT: 'Social',
  SOCIAL_ENVIRONMENTAL_CHEMICAL_AUDIT: 'Social, Environmental & Chemical',
};

export const ANALYTICS_EXCLUDED_COLLABORATION_STATUSES = {
  APPROVAL_DENIED: 'I4Q15LFTV2EAO6D6HP',
  BLACK_LISTED: '7IJ2CDPVT2KHWAWQJI',
  ENDED: 'CFVA0HKAH3N2HDNT1D',
  OFFBOARDING: 'QQ717C74R21NBAKWQD',
  PAUSED: '8QQZAX7AP4CGF9LAFO',
};

export const auditAnalyticsImpactAreaOptions = {};

auditAnalyticsImpactAreaOptions.raw = {
  ABSOLUTE:
    'auditsHistoricData.charts.auditsByImpactAreas.table.filter.absolute',
  PERCENTAGE:
    'auditsHistoricData.charts.auditsByImpactAreas.table.filter.percentage',
};

auditAnalyticsImpactAreaOptions.enumMapping = Object.keys(
  auditAnalyticsImpactAreaOptions.raw,
)
  .map(k => ({ key: k, text: auditAnalyticsImpactAreaOptions.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});
auditAnalyticsImpactAreaOptions.selectArrayOptions = Object.keys(
  auditAnalyticsImpactAreaOptions.raw,
)
  .map(k => ({ key: k, text: auditAnalyticsImpactAreaOptions.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));

export const auditFindingsUrgency = {};
auditFindingsUrgency.raw = {
  A: 'Low',
  B: 'Moderate',
  C: 'Medium',
  D: 'High',
  E: 'Extreme',
};

auditFindingsUrgency.mapping = { ...auditFindingsUrgency.raw };

export const certificatesDrilldownChartTypes = {
  reviewStatus: 'Certificates uploaded - by review status',
  expirationDate: 'Certificates expiration date - by month',
  expirationStatus: 'Certificate expiration status - by production steps',
};

export const auditsDrilldownChartTypes = {
  totalAudits: 'Total audits',
  upcomingAudits: 'Upcoming audits in the next month',
  auditFindingsByUrgency: 'Audit findings - by urgency',
  auditByImpactAreas: 'Comparison of findings created - by impact areas',
};

export const CERTIFICATE_ANALYTICS_MONTH_OF_EXPIRATION_ENUM = {
  EXPIRED: 'Expired',
  JAN: 'January',
  FEB: 'February',
  MAR: 'March',
  APR: 'April',
  MAY: 'May',
  JUN: 'June',
  JUL: 'July',
  AUG: 'August',
  SEP: 'September',
  OCT: 'October',
  NOV: 'November',
  DEC: 'December',
};

export const CERTIFICATE_ANALYTICS_EXPIRATION_STATUS_ENUM = {
  valid: 'Valid',
  expired: 'Expired',
  soonToExpire: 'Soon to expire',
};

export const stylePropertyCategories = {};
stylePropertyCategories.raw = {
  DEPARTMENTS: 'departments',
  BRANDS: 'brands',
  SEASONS: 'seasons',
  COLLECTIONS: 'collections',
  CUSTOM_PROPERTIES: 'customProperties',
};
stylePropertyCategories.enumMapping = Object.keys(stylePropertyCategories.raw)
  .map(k => ({ key: k, text: stylePropertyCategories.raw[k] }))
  .reduce((acc, obj) => ({ ...acc, [obj.key]: obj.key }), {});

export const AUDIT_AI_PROGRESS_STATUS_ENUM = {
  0: 'Extracting information...',
  25: 'Analyzing the audit...',
  50: 'Generating CAPAs...',
  75: 'Finalizing...',
  100: 'Completed!',
};

export const capaV2SourceTypes = {};
capaV2SourceTypes.raw = {
  AUDIT: 'Audit',
  SLCP: 'SLCP',
  FACTORY_VISIT: 'Factory Visit',
  OTHER: 'Other',
  // System-generated (amfori zero-tolerance incidents). Here for label display
  // + the list "Source Type" filter only — NOT offered in create/edit forms
  // (use capaV2SourceTypesEditable for those).
  ZERO_TOLERANCE: 'Zero Tolerance',
};

capaV2SourceTypes.mapping = { ...capaV2SourceTypes.raw };
capaV2SourceTypes.selectArrayOptions = Object.keys(capaV2SourceTypes.raw)
  .map(k => ({ key: k, text: capaV2SourceTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaV2SourceTypes.enumMapping = capaV2SourceTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

// User-creatable source types only — the subset a user may pick when creating
// or editing a finding/link. Excludes system-generated types (ZERO_TOLERANCE)
// that the backend create schema rejects. Use this for editable dropdowns;
// use capaV2SourceTypes for display + read-only filters.
export const capaV2SourceTypesEditable = {};
capaV2SourceTypesEditable.raw = {
  AUDIT: 'Audit',
  SLCP: 'SLCP',
  FACTORY_VISIT: 'Factory Visit',
  OTHER: 'Other',
};
capaV2SourceTypesEditable.mapping = { ...capaV2SourceTypesEditable.raw };
capaV2SourceTypesEditable.selectArrayOptions = Object.keys(
  capaV2SourceTypesEditable.raw,
)
  .map(k => ({ key: k, text: capaV2SourceTypesEditable.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaV2SourceTypesEditable.enumMapping =
  capaV2SourceTypesEditable.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const capaV2Urgencies = {};
capaV2Urgencies.raw = {
  A: 'Low',
  B: 'Moderate',
  C: 'Medium',
  D: 'High',
  E: 'Extreme',
};

capaV2Urgencies.selectArrayOptions = Object.keys(capaV2Urgencies.raw).map(
  k => ({
    key: k,
    text: capaV2Urgencies.raw[k],
  }),
);

capaV2Urgencies.mapping = { ...capaV2Urgencies.raw };

export const capaV2Statuses = {};
capaV2Statuses.raw = {
  TO_DO: 'To Do',
  IN_PROGRESS: 'In Progress',
  BLOCKED: 'Blocked',
  IN_REVIEW: 'In Review',
  CHANGES_REQUESTED: 'Changes Requested',
  DONE: 'Done',
};

capaV2Statuses.mapping = { ...capaV2Statuses.raw };
capaV2Statuses.selectArrayOptions = Object.keys(capaV2Statuses.raw)
  .map(k => ({ key: k, text: capaV2Statuses.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaV2Statuses.enumMapping = capaV2Statuses.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const capaV2FindingSources = {};
capaV2FindingSources.raw = {
  AI_GENERATED: 'AI Generated',
  USER_GENERATED: 'User Generated',
  AUTO_GENERATED: 'Auto Generated',
  OTHER: 'Other',
};

capaV2FindingSources.mapping = { ...capaV2FindingSources.raw };
capaV2FindingSources.selectArrayOptions = Object.keys(capaV2FindingSources.raw)
  .map(k => ({ key: k, text: capaV2FindingSources.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaV2FindingSources.enumMapping =
  capaV2FindingSources.selectArrayOptions.reduce(
    (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
    {},
  );

export const ENTITY_TAG_COLOR_OPTIONS = [
  { value: 'primary', label: 'Primary' },
  { value: 'secondary', label: 'Secondary' },
  { value: 'destructive', label: 'Destructive' },
  { value: 'warning', label: 'Warning' },
  { value: 'defualt', label: 'Default' },
];

export const capaPlanSourceTypes = {};
capaPlanSourceTypes.raw = {
  AUDIT: 'AUDIT',
  SLCP: 'SLCP',
};

capaPlanSourceTypes.mapping = { ...capaPlanSourceTypes.raw };
capaPlanSourceTypes.selectArrayOptions = Object.keys(capaPlanSourceTypes.raw)
  .map(k => ({ key: k, text: capaPlanSourceTypes.raw[k] }))
  .sort((a, b) => a.text.localeCompare(b.text));
capaPlanSourceTypes.enumMapping = capaPlanSourceTypes.selectArrayOptions.reduce(
  (acc, obj) => ({ ...acc, [obj.key]: obj.key }),
  {},
);

export const aiSummaryStatus = {};
aiSummaryStatus.raw = {
  PREPARING: 'PREPARING',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
};
aiSummaryStatus.mapping = { ...aiSummaryStatus.raw };
aiSummaryStatus.enumMapping = Object.keys(aiSummaryStatus.raw).reduce(
  (acc, key) => ({ ...acc, [key]: key }),
  {},
);

// Style Overview Tabs
export const OVERVIEW_TABS = {
  GENERAL: 'general',
  ECO_FOOTPRINT: 'eco-footprint',
};

export const OVERVIEW_TABS_CONFIG = [
  {
    key: OVERVIEW_TABS.GENERAL,
    translationKey: 'styles.edit.sidebar.menu.general',
  },
  {
    key: OVERVIEW_TABS.ECO_FOOTPRINT,
    translationKey: 'styles.edit.sidebar.menu.eco-footprint',
  },
];
// Style Type Unknown constant
export const STYLE_TYPE_ID_UNKNOWN = 'UNKNOWN';

/**
 * Data point type whose value is assigned by the platform, never supplied by a
 * user — e.g. `retraced_id`. Mirrors SYSTEM_DATA_POINT_TYPE in
 * `modules/companies/constants.ts`.
 */
export const SYSTEM_DATA_POINT_TYPE = 'SYSTEM';
